<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <Header />
   <!--  <b-button @click="showDialogEnviaListEspera = true">modal1</b-button>
    <b-button @click="activarModalEspera()">modal2</b-button> -->
    <!-- <b-button @click="showDialogEnviaListEsperaDatos = true">modal2</b-button> -->
    <div :class="styleMenu" v-if="menuDerecha">
      <ul class="sticky">
        <li>
          <div
            class="mt-4"
            @click="
              mostrarModalCrearCita(false);
              second = true;
              citaIsOverbooking = false;
            "
            v-if="
              clinicaEstaSeleccionada &&
              $localStorageService.can('bt_agendar_cc')
            "
          >
            <img alt="cita Medica" src="../assets/icons/cita-medica.png" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank"
                >Crear<br />
                cita</a
              >
            </p>
          </div>
          <div class="mt-4" @click="activarModalOverbooking()">
            <img alt="overbooking" src="../assets/icons/overbooking.png" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank">Overbooking</a>
            </p>
          </div>
          <div
            class="mt-4"
            @click="mostrarModalCrearCita(true)"
            v-if="
              clinicaEstaSeleccionada &&
              $localStorageService.can('CA_06_crear_cita_embajador')
            "
          >
            <img alt="calendar" src="../assets/icons/calendario.png" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank"
                >Cita<br />
                embajador</a
              >
            </p>
          </div>
          <div @click="activarModalEspera()" class="mt-4" v-if="$localStorageService.can('ICN_lista_espera')">
            <img alt="calendar" src="../assets/icons/documento.png" width="32" height="32" />
            <p style="font-weight: 600">
              <a style="color: #0663a1" target="_blank"
                >Lista de<br />
                espera</a
              >
            </p>
          </div>
        </li>
      </ul>
    </div>

    <b-card class="bCardAgenda">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span
            ><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon
          ></span>
          <span>Agenda dentalia {{ datosBusqueda.clinica.nombre }}</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>CA_06</div>
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <b-row class="">
        <b-col cols="12">
          <b-card
            style="
              border-radius: 20px;
              box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);
            "
          >
            <b-row>
              <b-col cols="3  ">
                <b-row>
                  <b-col cols="3">
                    <label>Clínica:</label>
                  <div class="mt-2Cambio">
                    <div class="mt-3 d-flex justify-content-start">
                      <h6>
                        <b-badge style=" background-color: white;">
                          <div class="d-flex justify-content-start">
                            <li
                            class="color mginLeft5 pointerCss"
                            style="
                              background-color: white;
                              height: 10px;
                              width: 19px;
                              border-top-left-radius: 6px;
                              border-top-right-radius: 6px;
                            "
                          ></li>
                          <p style="color: #808080;">Paciente nuevo</p>
                          </div>
                        </b-badge>
                      </h6>
                    </div>
                    <div class="d-flex justify-content-start">
                      <h6 style="margin-top: -6%;">
                        <b-badge style="background-color: white;">
                         <div class="d-flex justify-content-start">
                          <li
                          class="color mginLeft5 pointerCss"
                          style="
                            background-color: #00aa33;
                            height: 10px;
                            width: 19px;
                            border-top-left-radius: 6px;
                            border-top-right-radius: 6px;
                          "
                        ></li>
                        <p style="color: #808080;">Paciente recurrente</p>
                         </div>
                          
                        </b-badge>
                      </h6>
                    </div>
                  </div>
                  </b-col>
                  <b-col cols="9">
                    <div>
                       <v-select
                        style="
                          width: 100%;
                          border: 2px solid;
                          border-color: #aceaf4;
                          border-radius: 8px;
                        "
                        :clearable="false"
                        :options="listaClinicasFiltro"
                        v-model="datosBusqueda.clinica.clinicaID"
                        :reduce="(variable) => variable.id"
                        label="nombre"
                        placeholder="Selecciona una clínica"
                        :filterable="false"
                        @search="filtroClinicas"
                        
                        @input="actualizarNombreClinica(false)"
                      >
                        <span slot="no-options"
                          >No hay clinicas disponibles</span
                        >
                      </v-select>
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="6" align="center">
                <div class="selectWeek">
                  <button
                    style="color: #1b81af"
                    aria-label="Previous week"
                    class="vuecal__arrow vuecal__arrow--prev"
                    v-on:click="cambiarAnteriorSemana()"
                  >
                    &nbsp;<i class="angle"></i>&nbsp;
                  </button>
                  <span style="text-transform: uppercase">{{
                    semana.numeroSemana
                  }}</span>
                  <button
                    style="color: #1b81af"
                    aria-label="Next week"
                    class="vuecal__arrow vuecal__arrow--next"
                    v-on:click="cambiarSiguienteSemana()"
                  >
                    &nbsp;<i class="angle"></i>&nbsp;
                  </button>
                </div>
                 <div class="w-50">
                <b-form-datepicker
                  style="border: solid 1px #fff;"
                v-model="datosBusqueda.fechaActual"
                class="mb-2"
                in
                no-flip
                @click.native="seleccionarFechaCalendario"
              ></b-form-datepicker>
              </div>
              </b-col>

              <!--   <b-col cols="4" align="left">
                <b-button-group>
                  <b-button
                    variant="outline-primary"
                    @click="
                      mostrarModalCrearCita(false);
                      second = true;
                      citaIsOverbooking = false;
                      menuDerecha = false;
                    "
                    v-if="
                      clinicaEstaSeleccionada &&
                      $localStorageService.can('CA_06_crear_cita')
                    "
                  >
                    <b-icon icon="plus-circle"></b-icon>
                    Crear cita
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="activarModalOverbooking()"
                    v-if="clinicaEstaSeleccionada"
                  >
                    <b-icon icon="search"></b-icon>
                    Overbooking
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="mostrarModalCrearCita(true)"
                    v-if="
                      clinicaEstaSeleccionada &&
                      $localStorageService.can('CA_06_crear_cita_embajador')
                    "
                  >
                    <b-icon icon="plus-circle"></b-icon>
                    Crear cita embajador
                  </b-button>

                  <b-button variant="outline-primary" @click="buscarAgenda()">
                    <b-icon title="Refrescar" icon="arrow-repeat"></b-icon>
                  </b-button>
                </b-button-group>
              </b-col> -->

              <b-col style="margin-left: -5%;" cols="3">
                <div class="d-flex justify-content-start">
                  <b-button  variant="outline-info" @click="buscarAgenda()">
                    <em class="fa fa-refresh"></em>
                  </b-button>
                  <b-button variant="outline-info" class="ml-2" @click="menuDerecha = !menuDerecha">
                    <em class="fa fa-bars"></em>
                  </b-button>
                 </div>
                <div class="mt-3">
                  <div class="d-flex justify-content-start">
                    <label>Especialidades:</label>
                  </div>
                  <div >
                    
                   <div class="d-flex justify-content-start">
                    <span
                    class="EspecialidadesArray"
                    v-for="item in listaEspecialidades"
                    :key="item.id"
                    :title="item.nombre"
                    v-b-tooltip.hover
                  >
                    <span
                      @click="idEspecialidadFiltro = item.id"
                      class="color"
                      :style="`box-shadow: 0px 6px 6px 0px rgba(0,0,0,0.16);
                      border-radius: 60px;background-color: ${item.color}`"
                    ></span>
                  </span>
                   </div>
                   
                  </div>
                </div>
              
                <b-row
                  v-if="
                    listaEspecialidades !== undefined &&
                    listaEspecialidades.length > 0
                  "
                >
                  <b-col cols="4">
                    
                   
                    
                  </b-col>
                  <b-col cols="8">
                   
                  </b-col>
                </b-row>
       
              </b-col>
            </b-row>
          </b-card>

          <div class="mt-2 col-md-12"></div>

          <b-row>
            <b-col v-if="!loadingCAl">
              
              <cal-dentalia
                @mostrarDetalle="mostrarDetalle"
                @seleccionarFecha="seleccionarFechaPorDiaSemana"
                @crearCitaDesdeCalendario="crearCitaDesdeCalendario"
                :listaMotivosHerramientas="listaMotivosHerramientas"
                :listaMotivosCancelacion="listaMotivosCancelacion"
                :listaKitsPacienteNuevo="listaKitsPacienteNuevo"
                :idEspecialidadFiltro="idEspecialidadFiltro"
                ref="calDentalia"
              >
              </cal-dentalia>
            </b-col>
            <b-spinner v-if="loadingCAl" />
          </b-row>
        </b-col>
      </b-row>

      <b-modal
        size="lg"
        v-model="busquedaOverbooking"
        id="modalOverbooking"
        title="Buscar overbooking"
      >
        <div>
          <p>La búsqueda del overbooking toma en cuenta el doctor, especialidad, el horario de citas que ya están registradas en el calendario y el índice de confianza del paciente actual.</p>
          <div>
            <label style="width: 100%">
              <b-row style="width: 100%">
                <b-col cols="6">Paciente: <validacion /></b-col>
                <b-col cols="6" align="right"> </b-col>
              </b-row>
            </label>
            <b-form-group id="paciente-fg-agr-cita">
              <b-input-group id="paciente-ig-agr-cita">
                <template v-slot:append>
                  <b-button
                    v-if="mostrarBusquedaPaciente"
                    variant="outline-primary"
                    @click="llenarPacientesClinica()"
                  >
                    <b-icon class="searchicon" icon="search"></b-icon>
                  </b-button>
                  <b-button
                    v-if="!mostrarBusquedaPaciente"
                    variant="outline-warning"
                    :disabled="secondReagendar"
                    @click="limpiarPacienteSeleccionado"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </template>
                <b-form-input
               
                  v-if="
                    mostrarBusquedaPaciente &&
                    (tipoBusqueda === undefined ||
                      tipoBusqueda === null ||
                      tipoBusqueda === 1)
                  "
                  v-model="datosFormulario.nombrePacienteBusqueda"
                  placeholder="Ingresa un nombre"
                  type="text"
                  v-on:keypress="esLetra($event)"
                  v-b-tooltip.hover
                  title="Búsqueda básica por nombre completo del paciente"
                  @keydown.enter.prevent="llenarPacientesClinica()"
                ></b-form-input>
                <b-form-input
                  v-if="mostrarBusquedaPaciente && tipoBusqueda === 2"
         
                  v-model="datosFormulario.nombrePacienteBusqueda"
                  placeholder="Ingresa un nombre"
                  type="text"
                  v-b-tooltip.hover
                  title="Búsqueda avanzada (Nombre Paterno Materno DD-MM-YYYY). Ejem: (fern * * 1900-01-31). El comodin * funciona para los apellidos"
                  @keydown.enter.prevent="llenarPacientesClinica()"
                ></b-form-input>
                <b-form-input
                  v-if="mostrarBusquedaPaciente && tipoBusqueda === 3"
                  v-model="datosFormulario.nombrePacienteBusqueda"
                  :min="0"
                  placeholder="Ingresa un ID de PX"
                  type="number"
                  v-b-tooltip.hover
                  title="Id del paciente"
                  @keydown.enter.prevent="llenarPacientesClinica()"
                ></b-form-input>
                <b-form-input
                  v-if="!mostrarBusquedaPaciente"
                  disabled
                  required
                  v-model="datosFormulario.nombrePaciente"
                  placeholder="Selecciona un paciente de los resultados"
                  type="text"
                  v-on:keypress="esLetra($event)"
                ></b-form-input>
              </b-input-group>

              <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
                <div class="centrar">
                  <b-form-radio-group
                  v-if="overbookListaEspera == false"
                    id="btn-tipos_busqueda_paciente"
                    v-model="tipoBusqueda"
                    :options="[
                      { text: 'Búsq. normal', value: 1 },
                      { text: 'Búsq. avanzada', value: 2 },
                      { text: 'Búsq. ID', value: 3 },
                    ]"
                    :aria-describedby="ariaDescribedbyTipoBusqueda"
                    button-variant="outline-primary"
                    size="sm"
                    name="radio-btn-outline"
                  ></b-form-radio-group>
                </div>
              </b-form-group>

              <b-container class="bv-example-row">
                <b-row>
                  <div class="centrar">
                    <b-col cols="10">
                      <b-spinner small v-if="loadingPacientes" />
                      <span
                        class="tablePatients"
                        v-if="
                          !loadingPacientes &&
                          mostrarBusquedaPaciente &&
                          listaPacientes.length > 0
                        "
                        column="3"
                      >
                        <div class="mt-2 col-md-12"></div>
                        <b-table
                        v-if="!overbookListaEspera"
                          thead-tr-class="columnas"
                          :items="listaPacientes"
                          :fields="encabezados"
                          :per-page="registrosPorPagina"
                          :current-page="paginaActual"
                          :hover="true"
                          :small="true"
                          @row-clicked="setearPaciente"
                          class="parrafos"
                          responsive
                          fixed
                        >
                          <template v-slot:cell(id)="row">
                            <span>{{ row.item.id }}</span>
                          </template>
                          <template v-slot:cell(name)="row">
                            <div class="spanCien">
                              <span>
                                {{ row.item.esPacienteNuevo ? "*" : ""
                                }}{{ row.item.name }}
                              </span>
                            </div>
                          </template>
                          <template v-slot:cell(saldo)="row">
                            {{ row.item.saldo }}
                          </template>
                          <template v-slot:cell(plan)="row">
                            <span>
                              {{ plan.nombre }}
                            </span>
                          </template>
                        </b-table>
                        <b-pagination
                          v-if="listaPacientes.length > 15"
                          align="center"
                          v-model="paginaActual"
                          :total-rows="listaPacientes.length"
                          :per-page="registrosPorPagina"
                        ></b-pagination>
                      </span>
                    </b-col>
                  </div>
                </b-row>
              </b-container>
            </b-form-group>
          </div>


          <b-row>
            <b-col>
              <div v-if="datosFormulario.citaEmbajador">
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
                  v-if="datosFormulario.citaEmbajador"
                >
                  <label>Embajador </label>
                  <validacion />
                  <b-spinner
                    small
                    v-if="
                      loadingDoctoresClinica ||
                      loadingDoctores ||
                      loadingDoctoresEsp
                    "
                  />
                  <b-form-group v-else>
                    <v-select
                      :options="listaDoctores"
                      v-model="datosFormulario.idDoctor"
                      :reduce="(variable) => variable.id"
                      label="nombre"
                      placeholder="Selecciona un embajador (*)"
                      :disabled="secondReagendar || secondCitaDesdeCalendario"
                      @input="llenarEspecialidadesDoctor(true)"
                    >
                      <span slot="no-options"
                        >No hay embajadores disponibles</span
                      >
                    </v-select>
                    <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </div>
              <div v-else>
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
                >
                  <label>Doctor</label>
                  <validacion />
                  <b-form-group>
                    <v-select
                      :options="listaDoctoresFiltro"
                      :filterable="false"
                      @search="filtroDoctores"
                      v-model="datosFormulario.idDoctor"
                      :reduce="(variable) => variable.id"
                      label="nombre"
                      placeholder="Selecciona un doctor (*)"
                      :disabled="secondReagendar || secondCitaDesdeCalendario || overbookListaEspera"
                      @input="llenarEspecialidadesDoctor(true)"
                    >
                      <span slot="no-options">No hay doctores disponibles</span>
                    </v-select>
                    <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider :rules="{ required: true }" v-slot="errors">
                <label>Fecha</label>
                <validacion />
                <b-form-group>
                  <b-spinner small v-if="loadingHorariosClinica" />
                  <b-form-datepicker
                    id="fechacita-datepicker"
                    labelNoDateSelected="Fecha"
                    range
                    v-else
                    v-model="datosFormulario.fechaCita"
                    class="mb-2"
                    no-flip
                    in
                    :disabled="citaIsOverbooking"
                  ></b-form-datepicker>
                  <!-- :min="fechaMinima" -->
                  
                  <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
              <p style="font-size: 11px">Nota: La búsqueda se realizará en un rango de fechas, a partir del día seleccionado y agregando 7 días posteriores a la fecha seleccionada</p>
            </b-col>
            <b-col>
              <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="!datosFormulario.citaEmbajador"
              >
                <label>Especialidad</label>
                <validacion />
                <b-spinner small v-if="loadingEspecialidadesDoc" />
                <b-form-group v-else>
                  <v-select
                    id="idEspecialidad"
                    style="width: 100%"
                    :options="listaEspecialidadesDoctorFiltro"
                    :filterable="false"
                    @search="filtroEspecialidadesDoctor"
                    v-model="datosFormulario.idEspecialidad"
                    :reduce="(variable) => variable.id"
                    label="nombre"
                    placeholder="Selecciona una especialidad"
                    :disabled="secondReagendar || secondCitaDesdeCalendario"
                  >
                    <span slot="no-options"
                      >No hay especialidades disponible</span
                    >
                  </v-select>
                  <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <div class="d-flex justify-content-between">
            <b-button
            :disabled="
              datosFormulario.idPaciente == null &&
              datosFormulario.idDoctor == null &&
              datosFormulario.idEspecialidad == null
            "
            style="background-color: #17A2B8; border-color: #17A2B8; border-style: solid"
            @click="verificarOverbooking()"
            >Buscar overbooking</b-button
          >
          <!-- <b-button
            v-if="buscarOverbooking"
            style="background-color: #17A2B8; border-color: #17A2B8; border-style: solid"
            @click="enviarListaEspera()"
            >Enviar a lista de espera</b-button
          > -->
          </div>
          <div class="mt-4" v-if="buscarOverbooking">
            <div style="border-style: solid; border-color: #1dbdd5; border-radius: 20px; border-width: 2px; padding: 2%;" v-if="horarioDisponibleOverbooking.length > 0">
              <b-table
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="horarioDisponibleOverbooking"
              :fields="fieldsCitas"
            >
              <template #cell(agendar)="row">
                <b-button
                  size="sm"
                  @click="agendarOverbooking(row.item)"
                  class="mr-1"
                  variant="outline-primary"
                >
                  Agendar
                </b-button>
              </template>
            </b-table>
            </div>
            
            <b-pagination
            class="mt-4"
            v-if="horarioDisponibleOverbooking.length > 0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="overbooking"
              align="center"
            ></b-pagination>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button
            variant="outline-secondary"
            @click="
              cerrarOverbooking()
            "
            style="margin-left: 10px"
            >Cancelar
          </b-button>
        </template>
      </b-modal>
      <div>
        <b-modal
          size="lg"
          v-model="second"
          :title="
            (secondReagendar ? 'Reagendar Cita' : 'Asignar Cita') +
            (datosFormulario.citaEmbajador ? ' Embajador' : '')
          "
          scrollable
          v-if="clinicaEstaSeleccionada"
          no-close-on-backdrop
        >
          <div class="modalPadding">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form @submit.stop.prevent="handleSubmit(saveEvent)">
                <div>
                  <label style="width: 100%">
                    <b-row style="width: 100%">
                      <b-col cols="6">Paciente: <validacion /></b-col>
                      <b-col cols="6" align="right"> </b-col>
                    </b-row>
                  </label>
                  <b-form-group id="paciente-fg-agr-cita">
                    <b-input-group id="paciente-ig-agr-cita">
                      <template v-slot:append>
                        <b-button
                          v-if="mostrarBusquedaPaciente"
                          variant="outline-primary"
                          @click="llenarPacientesClinica()"
                        >
                          <b-icon class="searchicon" icon="search"></b-icon>
                        </b-button>
                        <b-button
                          v-if="!mostrarBusquedaPaciente"
                          variant="outline-warning"
                          :disabled="secondReagendar || citaIsOverbooking"
                          @click="limpiarPacienteSeleccionado"
                        >
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                      </template>
                      <b-form-input
                        v-if="
                          mostrarBusquedaPaciente &&
                          (tipoBusqueda === undefined ||
                            tipoBusqueda === null ||
                            tipoBusqueda === 1)
                        "
                        v-model="datosFormulario.nombrePacienteBusqueda"
                        placeholder="Ingresa un nombre"
                        type="text"
                        v-on:keypress="esLetra($event)"
                        v-b-tooltip.hover
                        title="Búsqueda básica por nombre completo del paciente"
                        @keydown.enter.prevent="llenarPacientesClinica()"
                      ></b-form-input>
                      <div  v-if="mostrarBusquedaPaciente && tipoBusqueda === 2">

                      </div>
                      <b-form-input
                        v-if="mostrarBusquedaPaciente && tipoBusqueda === 3"
                        v-model="datosFormulario.nombrePacienteBusqueda"
                        :min="0"
                        placeholder="Ingresa un ID de PX"
                        type="number"
                        v-b-tooltip.hover
                        title="Id del paciente"
                        @keydown.enter.prevent="llenarPacientesClinica()"
                      ></b-form-input>
                      <b-form-input
                        v-if="!mostrarBusquedaPaciente"
                        disabled
                        required
                        v-model="datosFormulario.nombrePaciente"
                        placeholder="Selecciona un paciente de los resultados"
                        type="text"
                        v-on:keypress="esLetra($event)"
                      ></b-form-input>
                    </b-input-group>

                    <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
                      <div class="centrar">
                        <b-form-radio-group
                          id="btn-tipos_busqueda_paciente"
                          v-model="tipoBusqueda"
                          :options="[
                            { text: 'Busq. Normal', value: 1 },
                            { text: 'Busq. Avanzada', value: 2 },
                            { text: 'Busq. ID', value: 3 },
                          ]"
                          :aria-describedby="ariaDescribedbyTipoBusqueda"
                          button-variant="outline-primary"
                          size="sm"
                          name="radio-btn-outline"
                        ></b-form-radio-group>
                      </div>
                    </b-form-group>
                    <div v-if="datosFormulario.indicadorProbabilidad" class="pt-3 d-flex justify-content-between contenedorTablaSinColor">
                 
                        <div class="pl-5">
                          <p style="font-weight: 600; font-size: 14px">Porcentaje de confianza: </p>
                        </div>
                        <div class="pr-5" style="font-size: 14px"><p>{{datosFormulario.indicadorProbabilidad * 10}}%</p></div>
                      
                    </div>

                    <b-container class="bv-example-row">
                      <b-row>
                        <div class="centrar">
                          <b-col cols="10">
                            <b-spinner small v-if="loadingPacientes" />
                            <span
                              class="tablePatients"
                              v-if="
                                !loadingPacientes &&
                                mostrarBusquedaPaciente &&
                                listaPacientes.length > 0
                              "
                              column="3"
                            >
                              <div class="mt-2 col-md-12"></div>
                              <b-table
                                thead-tr-class="columnas"
                                :items="listaPacientes"
                                :fields="encabezados"
                                :per-page="registrosPorPagina"
                                :current-page="paginaActual"
                                :hover="true"
                                :small="true"
                                @row-clicked="setearPaciente"
                                class="parrafos"
                                responsive
                                fixed
                              >
                                <template v-slot:cell(id)="row">
                                  <span>{{ row.item.id }}</span>
                                </template>
                                <template v-slot:cell(name)="row">
                                  <div class="spanCien">
                                    <span>
                                      {{ row.item.esPacienteNuevo ? "*" : ""
                                      }}{{ row.item.name }}
                                    </span>
                                  </div>
                                </template>
                                <template v-slot:cell(saldo)="row">
                                  {{ row.item.saldo }}
                                </template>
                                <template v-slot:cell(plan)="row">
                                  <span>
                                    {{ plan.nombre }}
                                  </span>
                                </template>
                              </b-table>
                              <b-pagination
                                v-if="listaPacientes.length > 15"
                                align="center"
                                v-model="paginaActual"
                                :total-rows="listaPacientes.length"
                                :per-page="registrosPorPagina"
                              ></b-pagination>
                            </span>
                          </b-col>
                        </div>
                      </b-row>
                    </b-container>
                  </b-form-group>
                </div>

                <b-row>
                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                      v-if="!secondReagendar"
                    >
                      <label>Motivo Cita</label>
                      <validacion />
                      <v-select
                        :options="tagmotivocitaDatosArrayFiltro"
                        :filterable="false"
                        @search="filtrotagmotivocitaDatos"
                        v-model="datosFormulario.idTagMotivoCita"
                        :reduce="(variable) => variable.idTagMotivoCita"
                        label="descripcionTagMotivoCita"
                        placeholder="Selecciona un motivo de cíta"
                        @input="setearMotivoTag($event)"
                      >
                        <span slot="no-options"
                          >No hay motivos de cíta disponibles</span
                        >
                      </v-select>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                    >
                      <label>Fecha</label>
                      <validacion />
                      <b-form-group>
                        <b-spinner small v-if="loadingHorariosClinica" />
                        <b-form-datepicker
                          id="fechacita-datepicker"
                          labelNoDateSelected="Fecha"
                          range
                          v-else
                          v-model="datosFormulario.fechaCita"
                          class="mb-2"
                          :min="fechaMinima"
                          in
                          no-flip
                          :disabled="citaIsOverbooking"
                        ></b-form-datepicker>
                        <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    <div v-if="datosFormulario.citaEmbajador">
                      <validation-provider
                        :rules="{ required: true }"
                        v-slot="errors"
                        v-if="datosFormulario.citaEmbajador"
                      >
                        <label>Embajador </label>
                        <validacion />
                        <b-spinner
                          small
                          v-if="
                            loadingDoctoresClinica ||
                            loadingDoctores ||
                            loadingDoctoresEsp
                          "
                        />
                        <b-form-group v-else>
                          <v-select
                            :options="listaDoctoresFiltro"
                            :filterable="false"
                            @search="filtroDoctores"
                            v-model="datosFormulario.idDoctor"
                            :reduce="(variable) => variable.id"
                            label="nombre"
                            placeholder="Selecciona un embajador (*)"
                            :disabled="
                              secondReagendar || secondCitaDesdeCalendario
                            "
                            @input="llenarEspecialidadesDoctor(true)"
                          >
                            <span slot="no-options"
                              >No hay embajadores disponibles</span
                            >
                          </v-select>
                          <validacion
                            :texto="errors.errors[0] ? errors.errors[0] : ' '"
                          />
                        </b-form-group>
                      </validation-provider>
                    </div>
                    <div v-else>
                      <validation-provider
                        :rules="{ required: true }"
                        v-slot="errors"
                      >
                        <label>Doctor</label>
                        <validacion />
                        <b-form-group>
                          <v-select
                            :options="listaDoctoresFiltro"
                            :filterable="false"
                            @search="filtroDoctores"
                            v-model="datosFormulario.idDoctor"
                            :reduce="(variable) => variable.id"
                            label="nombre"
                            placeholder="Selecciona un doctor (*)"
                            :disabled="
                              secondReagendar ||
                              secondCitaDesdeCalendario ||
                              citaIsOverbooking
                            "
                            @input="llenarEspecialidadesDoctor(true)"
                          >
                            <span slot="no-options"
                              >No hay doctores disponibles</span
                            >
                          </v-select>
                          <validacion
                            :texto="errors.errors[0] ? errors.errors[0] : ' '"
                          />
                        </b-form-group>
                      </validation-provider>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                      v-if="
                        !datosFormulario.citaEmbajador &&
                        !datosFormulario.esPacienteNuevo
                      "
                    >
                      <label>Especialidad</label>
                      <validacion />
                      <b-spinner small v-if="loadingEspecialidadesDoc" />
                      <b-form-group v-else>
                        <v-select
                          id="idEspecialidad"
                          style="width: 100%"
                          :options="listaEspecialidadesDoctorFiltro"
                          :filterable="false"
                          @search="filtroEspecialidadesDoctor"
                          v-model="datosFormulario.idEspecialidad"
                          :reduce="(variable) => variable.id"
                          label="nombre"
                          placeholder="Selecciona una especialidad"
                          :disabled="
                            secondReagendar ||
                            secondCitaDesdeCalendario ||
                            citaIsOverbooking
                          "
                        >
                          <span slot="no-options"
                            >No hay especialidades disponible</span
                          >
                        </v-select>
                        <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                      v-if="
                        !datosFormulario.citaEmbajador &&
                        !datosFormulario.esPacienteNuevo
                      "
                    >
                      <label>Tratamiento</label>
                      <validacion />
                      <b-form-group>
                        <v-select
                          style="width: 100%"
                          :options="listaTratamientosFiltro"
                          :filterable="false"
                          @search="filtroTratamientos"
                          :disabled="datosFormulario.esPacienteNuevo"
                          v-model="datosFormulario.idTratamiento"
                          :reduce="(variable) => variable.id"
                          label="nombre"
                          placeholder="Selecciona un tratamiento"
                          id="idTratamiento"
                        >
                          <span slot="no-options"
                            >No hay tratamientos disponibles</span
                          >
                        </v-select>
                        <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                        />
                      </b-form-group>
                    </validation-provider>

                    <div
                      v-if="
                        !datosFormulario.citaEmbajador &&
                        datosFormulario.esPacienteNuevo
                      "
                    >
                      <label>Tratamiento:</label>
                      {{ datosFormulario.nombreTratamiento }}
                    </div>
                  </b-col>
                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                      v-if="!datosFormulario.citaEmbajador"
                    >
                      <label>Sillón</label>
                      <validacion />
                      <b-form-group>
                        <v-select
                        style="width: 100%"
                        :options="listaSillones"
                        :filterable="false"
                        :disabled="
                            secondCitaDesdeCalendario || citaIsOverbooking
                          "
                        v-model="datosFormulario.sillon"
                        label="Sillón"
                        placeholder="Sillón"
                        id="idTratamiento"
                      >
                      <span slot="no-options"
                      >No hay sillones disponibles</span
                    >
                        </v-select>
                        <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
                  v-if="datosFormulario.citaEmbajador"
                >
                  <label>Sillón</label>
                  <validacion />
                  <b-form-group>
                    <v-select
                      id="idSillonEmbg"
                      style="width: 100%"
                      :options="listaSillonesEmbajadorFiltro"
                      :filterable="false"
                      @search="filtroSillonesEmbajador"
                      v-model="datosFormulario.sillon"
                      :reduce="(variable) => variable.valor"
                      label="nombre"
                      placeholder="Selecciona una sillón de embajador"
                      :disabled="secondReagendar || secondCitaDesdeCalendario"
                    >
                      <span slot="no-options">No hay sillones disponibles</span>
                    </v-select>
                    <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>

                <b-row>
                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                    >
                      <label>Hora inicio</label>
                      <validacion />
                      <b-form-group>
                        <vue-timepicker
                          id="idHoraInicio"
                          :disabled="citaIsOverbooking"
                          v-model="datosFormulario.horaInicio"
                          hide-disabled-items
                          format="HH:mm"
                          :minute-interval="15"
                          :hour-range="rangoHoraForm"
                          hide-clear-button
                        ></vue-timepicker>

                        <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col>
                    <validation-provider
                      :rules="{ required: true }"
                      v-slot="errors"
                    >
                      <label>Hora fin</label>
                      <validacion />
                      <b-form-group>
                        <vue-timepicker
                          id="idHoraFin"
                          v-model="datosFormulario.horaFin"
                          hide-disabled-items
                          format="HH:mm"
                          :minute-interval="15"
                          :hour-range="rangoHoraForm"
                          hide-clear-button
                          :disabled="citaIsOverbooking"
                        ></vue-timepicker>

                        <validacion
                          :texto="errors.errors[0] ? errors.errors[0] : ' '"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12" v-if="rangoHoraClinica !== undefined">
                    Horario(s) Clinica:
                    <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
                      hc
                    }}</b-badge>
                  </b-col>
                  <b-col cols="12" v-else>
                    <validacion
                      texto="Tu clinica no cuenta con ningún horario"
                    />
                  </b-col>

                  <div>
                    <b-col
                      cols="12"
                      v-if="!rangoHoraFormEsValido && !citaIsOverbooking"
                    >
                      <validacion texto="Selecciona un horario válido" />
                    </b-col>
                  </div>
                </b-row>

                <div class="mt-3 col-md-12"></div>

                <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
                >
                  <label>Observaciones</label>
                  <validacion />
                  <b-form-group>
                    <b-form-textarea
                      id="idObservaciones"
                      v-model="datosFormulario.comentario"
                      placeholder="Introduce tus observaciones"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                    <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>

                <div>
                  <b-form-checkbox id="checkbox-1" v-model="citaAdministrativa">
                    Marca esta opción si tu cita es administrativa
                  </b-form-checkbox>
                </div>

                <div class="mt-2 col-md-12"></div>

                <b-button
                  ref="submitAgregarAgenda"
                  type="submit"
                  style="visibility: hidden"
                ></b-button>
              </b-form>
            </validation-observer>

            <div class="mt-2 col-md-12"></div>
            <div class="mt-2 col-md-12"></div>
          </div>
          <template v-slot:modal-footer>
            <b-button
              variant="outline-info"
              @click="submitAgregarAgenda"
            >
              <span v-if="!guardando">Guardar</span>
              <span v-if="guardando">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
            </b-button>
            <b-button
              variant="outline-secondary"
              @click="
                  second = false;
                  menuDerecha = true;
              "
              style="margin-left: 10px"
              >Cancelar
            </b-button>
          </template>

        </b-modal>
      </div>

      <vue-context ref="menu">
        <li
          v-show="
            activarIniciarSesion(pacienteSeleccionado) && fechaLlegada == null
          "
          @click.prevent="asignarHoraLlegadaPaciente(pacienteSeleccionado)"
        >
          <a href="#">Asignar hora de llegada</a>
        </li>
        <li
          v-show="
            activarIniciarSesion(pacienteSeleccionado) && fechaLlegada != null
          "
          @click="iniciarSesion(pacienteSeleccionado)"
        >
          <a href="#">Iniciar sesión</a>
        </li>
        <li
          v-if="
            activarConfirmarCita(pacienteSeleccionado) &&
            pacienteSeleccionado.isCitaConfirmada == false
          "
          @click.prevent="showDialogConfirmarCita = true"
        >
          <a href="#">Confirmar cita</a>
        </li>
        <li
          v-if="activarCancelarCita(pacienteSeleccionado)"
          @click.prevent="cancelarCita(pacienteSeleccionado)"
        >
          <a href="#">Cancelar cita</a>
        </li>
        <li
          v-if="activarReagendar(pacienteSeleccionado)"
          @click.prevent="reagendarCita(pacienteSeleccionado)"
        >
          <a href="#">Reagendar cita</a>
        </li>
        <li
          v-if="activarReasignarDoctor(pacienteSeleccionado)"
          @click.prevent="reasignarDoctor(pacienteSeleccionado)"
        >
          <a href="#">Reasignar doctor</a>
        </li>
        <li @click.prevent="activarListaEspera(pacienteSeleccionado)">
          <a href="#">Lista de espera</a>
        </li>
      </vue-context>
      <b-modal
        size="xl"
        v-model="showDetail"
        id="modDetalleCita"
        title="Detalles de la cita"
        scrollable
      >
        <b-row style="background-color: #f8f8f8">
          <b-col md="5" style="background-color: #f8f8f8">
            <div class="d-flex justify-content-center mt-3">
              <img
                width="22%"
                @contextmenu.prevent="$refs.menu.open"
                src="../assets/icons/diente-blanco.png"
              />
            </div>
            <div class="mt-3 d-flex justify-content-center">
              <p style="font-weight: 600; color:#1C4A81">Paciente: {{datosDetalle.nombrePaciente}}</p>
            </div>

            <vue-custom-scrollbar
              class="scroll-area"
              :settings="settings"
            >
              <div
                class="mt-5"
                style="justify-content: center; margin-left: 20%"
              >
                <div
                class="animacionBoton"
                  v-for="paciente in datosDetalleOriginal"
                  v-bind:key="paciente.idPaciente"
                  @click="cambioPacienteSeleccionado(paciente)"
                  :style="paciente.colorCitaOverbooking"
                >
                  <div  style="margin: 4%">
                    <p
                      v-if="
                        paciente ==
                        datosDetalleOriginal[posicionPacienteOriginal]
                      "
                      style="font-weight:600; font-size: 12px; color: #327fb1"
                    >
                      Paciente original
                    </p>
                    <p
                      :style="
                        paciente ==
                        datosDetalleOriginal[posicionPacienteOriginal]
                          ? 'font-size: 14px;'
                          : 'font-size: 14px; margin-top: 35px'
                      "
                    >
                      {{ paciente.nombrePaciente }}
                    </p>
                  </div>
                </div>
              </div>
            </vue-custom-scrollbar>
          </b-col>
          <b-col md="7">
            <div style="margin-top: 3%">
              <strong style="color: #17a2b8">Información de la cita</strong>

              <div style="padding: 4%">
                <b-table-simple small="small">
                  <b-tbody class="text-left">
                    <b-tr>
                      <b-th>Medio de contacto</b-th>
                      <b-td>{{ datosDetalle.canalOrigen }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Persona que registro</b-th>
                      <b-td>{{ datosDetalle.usuarioAlta }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Paciente</b-th>
                      <b-td>{{ datosDetalle.nombrePaciente }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>ID paciente</b-th>
                      <b-td>{{ datosDetalle.idPaciente }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Fecha de nacimiento</b-th>
                      <b-td>{{ datosDetalle.fechaNacimientoCompleta }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Teléfono</b-th>
                      <b-td
                        ><span
                          v-if="
                            datosDetalle !== undefined &&
                            datosDetalle.celular !== undefined &&
                            datosDetalle.celular !== null
                          "
                          >{{
                            datosDetalle.celular | VMask("(###) - ### - ####")
                          }}</span
                        >
                        <span v-else>Sin número</span></b-td
                      >
                    </b-tr>
                    <b-tr>
                      <b-th>Fecha</b-th>
                      <b-td
                        >{{ datosDetalle.fechaCita | formatoFecha }}
                        {{
                          datosDetalle.horaInicioCasilla | formatoHoraDeHora
                        }}</b-td
                      >
                    </b-tr>
                    <b-tr>
                      <b-th>Doctor</b-th>
                      <b-td
                        >{{ datosDetalle.idDoctor }}-{{
                          datosDetalle.nombreDoctor
                        }}
                        ({{ datosDetalle.nombreEspecialidadDoctor }})</b-td
                      >
                    </b-tr>
                    <b-tr>
                      <b-th>Horario</b-th>
                      <b-td>
                        Entre
                        {{ datosDetalle.horaInicioCasilla | formatoHoraDeHora }}
                        y
                        {{
                          datosDetalle.horaFinCasilla | formatoHoraDeHora
                        }}</b-td
                      >
                    </b-tr>
                    <b-tr>
                      <b-th>No. de sillón</b-th>
                      <b-td>{{ datosDetalle.sillon }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Estatus</b-th>
                      <b-td>{{ datosDetalle.estatusCita }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Tratamiento</b-th>
                      <b-td>
                        <p
                          v-if="
                            datosDetalle.tratamientos !== undefined &&
                            datosDetalle.tratamientos.length > 0
                          "
                        >
                          <span
                            v-for="tratamiento in datosDetalle.tratamientos"
                            v-bind:key="tratamiento.idTratamiento"
                          >
                            {{ tratamiento.nombreTratamiento }}<br />
                          </span></p
                      ></b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Motivo de cita</b-th>
                      <b-td>{{ datosDetalle.motivoCitaTag }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th>Observaciones</b-th>
                      <b-td>
                        <div class="word-break" v-for="(com, index) in datosDetalle.observaciones" :key="index">
                          <span v-if="com.usuarioAlta !== null">({{ com.usuarioAlta }}) </span>
                          <span v-if="com.fechaAlta !== null">({{ com.fechaAlta | formatoFechaHoraTexto }}) </span>
                          <span>{{ com.observacion }}.</span>
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
            <div>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(agregarObservacion)">
                  <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                  >
                    <label>Agregar observaciones</label>
                    <validacion />
                    <b-form-group>
                      <b-form-textarea
                        id="idObservaciones"
                        v-model="datosDetalle.comentarioNuevo"
                        placeholder="Introduce tus observaciones"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                      />
                    </b-form-group>
                  </validation-provider>

                  <b-button
                    ref="submitAgregarObs"
                    type="submit"
                    style="visibility: hidden"
                  >
                  </b-button>
                </b-form>
              </validation-observer>
            </div>
          </b-col>
        </b-row>

        <template v-slot:modal-footer>
          <b-button
            variant="outline-info"
            :disabled="datosDetalle.comentarioNuevo == null || guardando"
            @click="submitAgregarObs"
          >
            <span v-if="!guardando">Guardar</span>
            <span v-if="guardando">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="
              showDetail = false;
              menuDerecha = true;
            "
            style="margin-left: 10px"
            >Cancelar
          </b-button>
        </template>
        <!-- <template v-slot:modal-footer>
          <div style="margin: 0 auto">
            <b-button variant="outline-danger" @click="showDetail = false; menuDerecha = true;" 
              >Cerrar</b-button
            >
          </div>
        </template> -->
      </b-modal>

      <b-modal
        v-model="modalReasignarDoctor"
        id="modalReasignarDoctor"
        title="Reasignar doctor"
        scrollable
      >
        <validation-observer ref="observ" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(guardarReasignarDoctor)">
            <b-row>
              <b-col>
                <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
                >
                  <label>Doctor</label>
                  <validacion />
                  <b-form-group>
                    <v-select
                      style="width: 100%"
                      :options="listaDoctores"
                      v-model="datosFormularioReasignar.idDoctor"
                      :reduce="(variable) => variable.id"
                      label="nombre"
                      placeholder="Selecciona un doctor (*)"
                    >
                      <span slot="no-options">No hay doctores disponibles</span>
                    </v-select>
                    <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-button
              ref="submitReasignarDoctor"
              type="submit"
              style="visibility: hidden"
            ></b-button>
          </b-form>
        </validation-observer>

        <b-row>
          <b-col cols="12">
            <strong>Paciente:</strong>
            {{ datosFormularioReasignar.nombrePaciente }}
          </b-col>
          <b-col cols="12">
            <strong>Fecha de nacimiento:</strong>
            {{ datosFormularioReasignar.fechaNacimientoCompleta }}
          </b-col>
          <b-col cols="6">
            <strong>Fecha:</strong>
            {{ datosFormularioReasignar.fechaCita | formatoFecha }}
            {{ datosFormularioReasignar.horaInicioCasilla | formatoHoraDeHora }}
          </b-col>
          <b-col cols="6">
            <strong>Horario:</strong>
            Entre
            {{ datosFormularioReasignar.horaInicioCasilla | formatoHoraDeHora }}
            y
            {{ datosFormularioReasignar.horaFinCasilla | formatoHoraDeHora }}
          </b-col>

          <b-col cols="6">
            <strong>Status:</strong>
            {{ datosFormularioReasignar.estatusCita }}
          </b-col>

          <b-col
            cols="6"
            v-if="
              datosFormularioReasignar.tratamientos !== undefined &&
              datosFormularioReasignar.tratamientos.length > 0
            "
          >
            <strong>Tratamiento:</strong>
            <span
              v-for="tratamiento in datosFormularioReasignar.tratamientos"
              v-bind:key="tratamiento"
            >
              {{ tratamiento.nombreTratamiento }}<br />
            </span>
          </b-col>

          <b-col cols="12">
            <strong>Observaciones:</strong>
            {{ datosFormularioReasignar.comentario }}
          </b-col>
        </b-row>

        <template v-slot:modal-footer>
          <b-button variant="outline-primary" @click="submitReasignarDoctor"
            >Guardar</b-button
          >
          <b-button
            variant="outline-danger"
            class="botones"
            @click="modalReasignarDoctor = false"
            size="lg"
            style="margin-left: 10px"
            >Cancelar
          </b-button>
        </template>
      </b-modal>

      <HojaBienvenida
        :nombrePaciente="nombrePaciente"
        :tagMotivoCita="nombreTagMotivoCita"
        :idCita="idCita"
        :idTipoDenticion="idTipoDenticion"
        :nombreTutor="nombreTutor"
      >
      </HojaBienvenida>
      <b-modal
        v-model="showDialogIniciarSession"
        id="modIniciarSesion"
        title="¿Deseas iniciar la sesión?"
        scrollable
      >
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(iniciarSesionServ)">
            <validation-provider
              name="ReqHerr"
              :rules="{ required: true }"
              v-slot="validationContext"
              v-if="
                !citaSeleccionada.pacienteEsNino &&
                !citaSeleccionada.especialistaNino &&
                !citaSeleccionada.citaEmbajador &&
                noExistePTIVigente
              "
            >
              <label>¿Requiere herramientas?</label><validacion />
              <b-form-group>
                <v-select
                  style="width: 100%"
                  :clearable="false"
                  :options="listaSINOFiltro"
                  :filterable="false"
                  @search="filtrolListaSINO"
                  v-model="datosIniciarSesion.herramientas"
                  :reduce="(variable) => variable.valor"
                  label="etiqueta"
                  placeholder="¿La sesión requiere herramientas?"
                  id="idReqHerramientas"
                  name="nmReqHerramientas"
                >
                  <span slot="no-options">No hay valores disponibles</span>
                </v-select>
                <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
                />
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="MotReqHerr"
              :rules="{ required: true }"
              v-slot="validationContext"
              v-if="
                !datosIniciarSesion.herramientas &&
                !citaSeleccionada.especialistaNino &&
                !citaSeleccionada.citaEmbajador &&
                noExistePTIVigente
              "
            >
              <label>Motivo para no requerir herramientas</label><validacion />
              <b-form-group>
                <v-select
                  style="width: 100%"
                  :clearable="false"
                  :options="listaMotivosHerramientasFiltro"
                  :filterable="false"
                  @search="filtrolListaMotivosHerramientas"
                  v-model="datosIniciarSesion.idMotivoHerramienta"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Motivo para no requerir herramientas"
                  id="idMotReqHerramientas"
                  name="nmMotReqHerramientas"
                >
                  <span slot="no-options">No hay valores disponibles</span>
                </v-select>
                <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
                />
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="ReqHerr"
              :rules="{ required: true }"
              v-slot="validationContext"
              v-if="
                listaPlanesPaciente !== undefined &&
                listaPlanesPaciente.length > 0
              "
            >
              <label>Plan del paciente</label><validacion />
              <b-form-group
                :state="planPacienteState"
                invalid-feedback="El plan del paciente es requerido"
              >
                <v-select
                  style="width: 100%"
                  :clearable="false"
                  :options="listaPlanesPaciente"
                  v-model="datosIniciarSesion.idPlan"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Selecciona una plan"
                  id="idPlanPac"
                >
                  <span slot="no-options">No hay planes disponibles</span>
                </v-select>
              </b-form-group>
              <validacion
                :texto="
                  validationContext.errors[0]
                    ? validationContext.errors[0]
                    : ' '
                "
              />
            </validation-provider>

            <validation-provider
              name="ReqHerr"
              :rules="{ required: true }"
              v-slot="validationContext"
              v-if="listaKitsCita !== undefined && listaKitsCita.length > 0"
            >
              <label>Kit del tratamiento de la cita</label><validacion />
              <b-form-group
                :state="kitTratamientoCita"
                invalid-feedback="El kit es requerido"
              >
                <v-select
                  style="width: 100%"
                  :clearable="false"
                  :options="listaKitsCitaFiltro"
                  :filterable="false"
                  @search="filtrolListaKitsCitaFiltro"
                  v-model="datosIniciarSesion.idKit"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Selecciona una kit"
                  id="idKitTratCita"
                >
                  <span slot="no-options">No hay kits disponibles</span>
                </v-select>
              </b-form-group>
              <validacion
                :texto="
                  validationContext.errors[0]
                    ? validationContext.errors[0]
                    : ' '
                "
              />
            </validation-provider>

            <b-button
              ref="submitIniciarSesion"
              type="submit"
              style="visibility: hidden"
            ></b-button>
          </b-form>
        </validation-observer>

        <template v-slot:modal-footer>
          <b-spinner small v-if="loadingExistePTI"></b-spinner>
          <b-button
            variant="outline-primary"
            @click="submitIniciarSesion"
            v-if="!loadingExistePTI"
            >Aceptar</b-button
          >
          <b-button
            variant="outline-danger"
            @click="showDialogIniciarSession = false"
            >Cancelar
          </b-button>
        </template>
      </b-modal>

      <b-modal
        v-model="showDialogConfirmarCita"
        id="modConfirmarCita"
        title="¿Deseas confirmar la cita?"
        scrollable
      >
        <template v-slot:modal-footer>
          <b-button variant="outline-primary" @click="submitConfirmarCita"
            >Aceptar</b-button
          >
          <b-button
            variant="outline-danger"
            @click="showDialogConfirmarCita = false"
            >Cancelar
          </b-button>
        </template>
      </b-modal>
      <b-modal
        size="lg"
        v-model="showDialogCancelarCita"
        id="modCancelarCita"
        title="¿Deseas cancelar la cita?"
        scrollable
      >
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(cancelarCitaServ)">
            <validation-provider
              name="MotCancelar"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <label>Motivo de cancelación</label><validacion />
              <b-form-group>
                <v-select
                  style="width: 100%"
                  :options="listaMotivosCancelacion"
                  v-model="datosCancelarCita.motivoCancelacion"
                  :reduce="(variable) => variable.id"
                  label="descripcion"
                  placeholder="Selecciona el motivo de cancelación"
                >
                  <span slot="no-options">No hay valores disponibles</span>
                </v-select>
                <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
                />
              </b-form-group>
            </validation-provider>

            <validation-provider
              name="DescCancelar"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <label>Descripción de cancelación</label><validacion />
              <b-form-group>
                <b-textarea
                  v-model="datosCancelarCita.descripcionCancelacion"
                  placeholder="Descripción de cancelación"
                ></b-textarea>
                <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
                />
              </b-form-group>
            </validation-provider>

            <b-button
              ref="submitCancelarCita"
              type="submit"
              style="visibility: hidden"
            ></b-button>
          </b-form>
        </validation-observer>
        <template v-slot:modal-footer>
          <b-button variant="outline-primary" @click="submitCancelarCita"
            >Aceptar</b-button
          >
          <b-button
            variant="outline-danger"
            @click="showDialogCancelarCita = false"
            >Cancelar
          </b-button>
        </template>
      </b-modal>
      <b-modal 
          size="lg"
          v-model="modalAvisoOverbooking"
          id="modCancelarCita"
          title="Aviso"
          scrollable>
          <div class="p-3">
            <p>No se puede hacer overbooking, debido al indicador de confianza que presenta el(los) paciente(s) actualmente agendado(s) ó, sobrepasan el 100% de probabilidad de asistencia a cita.</p>
        <div class="d-flex justify-content-center mt-4 contenedorTablaSinColor">
          <b-table 
        
                        v-if="!overbookListaEspera"
                          thead-tr-class="columnasTablaSinColor"
                          :items="citasAgendadas"
                          :fields="encabezadosOverbook"
                          :per-page="registrosPorPagina"
                          :current-page="paginaActual"
                          :hover="true"
                          :small="true"
                          style="font-size: 13px; padding: 0.75rem;"
                          responsive
                          fixed
                        >
                        <template v-slot:cell(Porcentaje)="row">
                          <span>
                            {{ row.item.indicadorProbabilidad * 10 }}%
                          </span>
                        </template>

                        </b-table>
        </div>
          </div>
        <template v-slot:modal-footer>
          <b-button
            variant="outline-info"
            @click="busquedaOverbooking = true; modalAvisoOverbooking = false;"
          >
            <span v-if="!guardando">Buscar overbooking</span>
            <span v-if="guardando">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="
            modalAvisoOverbooking = false;
             
            "
            style="margin-left: 10px"
            >Cancelar
          </b-button>
        </template>
      </b-modal>
      <b-modal
      size="lg"
      v-model="showDialogEnviaListEspera"
      id="modEnviaListEspera"
      title="Enviar a lista de espera"
      scrollable
      
  >
  <div>
    <p>Seleccione un motivo y comentarios sobre el porqué se enviará este paciente a lista de espera.</p>
    
          <b-row class="mt-3">

            <b-col class="col-6">
              <label>Paciente:</label>
              <b-form-input
              id="fechacitafin-datepicker"
              v-model="datosDetalle.nombrePaciente"
              class="mb-2"
              disabled
          ></b-form-input>
            </b-col>
            <b-col class="col-6">
              <label>Motivo:</label>
              <v-select
                 
                  label="descripcion"
                  :options="listaMotivo"
                  placeholder="Motivos de envío a lista de espera"
                  v-model="motivoEspera.idMotivoEspera"
                  :reduce="(item) => item.id"
              >
                <span slot="no-options">No hay motivos disponibles</span>
              </v-select>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Fecha inicio de cita solicitada</label>
                <validacion />
                <b-form-group>
                  <b-spinner small v-if="loadingFechaInicioCitaSoli" />
                  <b-form-datepicker
                      id="fechacita-datepicker"
                      labelNoDateSelected="Fecha inicio de cita solicitada"
                      v-model="datosFormulario.fechaInicio"
                      range
                      class="mb-2"
                      :min="fechaMinima"
                      in
                      no-flip
                  ></b-form-datepicker>
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Fecha fin de cita Solicitada</label>
                <validacion />
                <b-form-group>
                  <b-spinner small v-if="loadingFechaFinCitaSoli" />
                  <b-form-datepicker
                      id="fechacitafin-datepicker"
                      labelNoDateSelected="Fecha fin de cita Solicitada"
                      v-model="datosFormulario.fechaFin"
                      range
                      class="mb-2"
                      :min="fechaMinima"
                      in
                      no-flip
                  ></b-form-datepicker>
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col class="text-left">
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Fecha fin de cita perdida o cancelada </label>
                <validacion />
                <b-form-group>
                  <b-spinner small v-if="loadingFechaFinCitaPerdida" />
                  <b-form-datepicker
                      id="fechacita-finperdida-datepicker"
                      labelNoDateSelected="Fecha de cita Solicitada"
                      range
                      class="mb-2"
                      :min="fechaMinima"
                      in
                      no-flip
                      v-model="datosFormulario.fechaCitaPerdida"
                  ></b-form-datepicker>
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Días de exclusión:</label>
                <v-select
                    style="width: 100%"
                    name="dia"
                    placeholder="--Seleccionar--"
                    label="descripcion"
                    multiple
                    :options="listaDias"
                    v-model="datosFormulario.dias"
                ><span slot="no-options">No hay dias disponibles</span>
                </v-select>
              </b-form-group>
              <b-form-invalid-feedback
                  :state="datosFormulario.dias!= null && datosFormulario.dias.length > 0"
              >
                Este campo es obligatorio
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row class="mt-4 text-center">
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora inicio</label>
                <validacion />
                <b-form-group>
                  <vue-timepicker
                      id="idHoraInicio"
                      v-model="datosFormulario.horaInicio"
                      hide-disabled-items
                      format="HH:mm"
                      :minute-interval="15"
                      :hour-range="rangoHoraForm"
                      hide-clear-button
                  ></vue-timepicker>
        
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
        
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Hora fin</label>
                <validacion />
                <b-form-group>
                  <vue-timepicker
                      id="idHoraFin"
                      v-model="datosFormulario.horaFin"
                      hide-disabled-items
                      format="HH:mm"
                      :minute-interval="15"
                      :hour-range="rangoHoraForm"
                      hide-clear-button
                  ></vue-timepicker>
        
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" v-if="rangoHoraClinica !== undefined">
              Horario(s) Clinica:
              <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
                  hc
                }}</b-badge>
            </b-col>
            <b-col cols="12" v-else>
              <validacion
                  texto="Tu clinica no cuenta con ningún horario"
              />
            </b-col>
        
            <div>
              <b-col
                  cols="12"
                  v-if="!rangoHoraFormEsValido"
              >
                <validacion texto="Selecciona un horario válido" />
              </b-col>
            </div>
          </b-row>

          <b-row class="mt-4">
            <b-col class="col-2"><label>Comentarios:</label></b-col>
          </b-row>
          <b-row>
            <b-col class="col-12">
              <b-form-textarea
                  id="textarea"
                  v-model="motivoEspera.comentario"
                  placeholder="Comentarios"
                  rows="3"
                  max-rows="6"
              ></b-form-textarea>
            </b-col>
          </b-row>
  </div>
  <!-- <EnviarListaEsperaMotivoModal :nombrePaciente="'MARIA MARIA MARIA'" @listaMotivo="listaConfirmarCita = $event"></EnviarListaEsperaMotivoModal> -->
    <template v-slot:modal-footer>
      <b-button variant="outline-info" @click="llenarDatosEsperaOverbook"
      >Aceptar</b-button
      >
      <b-button
          variant="outline-secondary"
          @click="showDialogEnviaListEspera = false"
      >Cancelar
      </b-button>
    </template>
  </b-modal>
  <b-modal
      v-model="showDialogEnviaListEsperaDatos"
      id="modEnviaListEspera"
      title="Enviar a lista de espera"
      scrollable
      size="lg"
  >
  <div>
    <div>
      <label style="width: 100%">
        <b-row style="width: 100%">
          <b-col cols="6">Paciente: <validacion /></b-col>
          <b-col cols="6" align="right"> </b-col>
        </b-row>
      </label>
      <b-form-group id="paciente-fg-agr-cita">
        <b-input-group id="paciente-ig-agr-cita">
          <template v-slot:append>
            <b-button
              v-if="mostrarBusquedaPaciente && tipoBusqueda !== 2"
              variant="outline-primary"
              @click="llenarPacientesClinica()"
            >
              <b-icon class="searchicon" icon="search"></b-icon>
            </b-button>
            <b-button
              v-if="!mostrarBusquedaPaciente"
              variant="outline-warning"
              :disabled="secondReagendar"
              @click="limpiarPacienteSeleccionado"
            >
              <b-icon icon="trash-fill"></b-icon>
            </b-button>
          </template>
          <b-form-input
         
            v-if="
              mostrarBusquedaPaciente &&
              (tipoBusqueda === undefined ||
                tipoBusqueda === null ||
                tipoBusqueda === 1)
            "
            v-model="datosFormulario.nombrePacienteBusqueda"
            placeholder="Ingresa un nombre"
            type="text"
            v-on:keypress="esLetra($event)"
            v-b-tooltip.hover
            title="Búsqueda básica por nombre completo del paciente"
            @keydown.enter.prevent="llenarPacientesClinica()"
          ></b-form-input>

          <!--                      Busqueda avanzada                               -->
          <div  v-if="mostrarBusquedaPaciente && tipoBusqueda === 2">
            <br>
            <b-row>
              <b-col cols="col-sm-12 col-md-3 col-lg-3">
                <b-form-input
                    style="width: 100%"
                    v-model="nombre"
                    placeholder=" nombre"
                    type="text"
                    v-on:keypress="esLetra($event)"
                    v-b-tooltip.hover
                    title="Búsqueda básica por nombre del paciente"
                    v-on:keyup.enter="getPatientsV2()"
                    class="input-buscador"
                ></b-form-input>
              </b-col>
              <b-col cols="col-sm-12 col-md-3 col-lg-3">
                <b-form-input
                    style="width: 100%"
                    v-model="apellidoPaterno"
                    placeholder="apellido paterno"
                    type="text"
                    v-on:keypress="esLetra($event)"
                    v-b-tooltip.hover
                    title="Apellido Paterno"
                    v-on:keyup.enter="getPatientsV2()"
                    class="input-buscador"
                ></b-form-input>
              </b-col>
              <b-col cols="col-sm-12 col-md-3 col-lg-3">
                <b-form-input
                    style="width: 100%"
                    v-model="apellidoMaterno"
                    placeholder="apellido materno"
                    type="text"
                    v-on:keypress="esLetra($event)"
                    v-b-tooltip.hover
                    title="Apellido Materno"
                    v-on:keyup.enter="getPatientsV2()"
                    class="input-buscador"
                ></b-form-input>
              </b-col>
              <b-col cols="col-sm-12 col-md-1 col-lg-1">
                <b-button size="sm"
                          v-if="datosCita == null"
                          variant="info"
                          style="margin: auto;"
                          @click="getPatientsV2()">
                  <span ><em class="buscar_svg" style="height: 16px;"></em></span>
                </b-button>
              </b-col>
            </b-row>
          </div>

          <b-form-input
            v-if="mostrarBusquedaPaciente && tipoBusqueda === 3"
            v-model="datosFormulario.nombrePacienteBusqueda"
            :min="0"
            placeholder="Ingresa un ID de PX"
            type="number"
            v-b-tooltip.hover
            title="Id del paciente"
            @keydown.enter.prevent="llenarPacientesClinica()"
          ></b-form-input>
          <b-form-input
            v-if="!mostrarBusquedaPaciente"
            disabled
            required
            v-model="datosFormulario.nombrePaciente"
            placeholder="Selecciona un paciente de los resultados"
            type="text"
            v-on:keypress="esLetra($event)"
          ></b-form-input>
        </b-input-group>

        <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
          <div class="centrar">
            <b-form-radio-group
            v-if="overbookListaEspera == false"
              id="btn-tipos_busqueda_paciente"
              v-model="tipoBusqueda"
              :options="[
                { text: 'Búsq. normal', value: 1 },
                { text: 'Búsq. avanzada', value: 2 },
                { text: 'Búsq. ID', value: 3 },
              ]"
              :aria-describedby="ariaDescribedbyTipoBusqueda"
              button-variant="outline-primary"
              size="sm"
              name="radio-btn-outline"
            ></b-form-radio-group>
          </div>
        </b-form-group>

        <b-container class="bv-example-row">
          <b-row>
            <div class="centrar">
              <b-col cols="10">
                <b-spinner small v-if="loadingPacientes" />
                <span
                  class="tablePatients"
                  v-if="
                    !loadingPacientes &&
                    mostrarBusquedaPaciente &&
                    listaPacientes.length > 0
                  "
                  column="3"
                >
                  <div class="mt-2 col-md-12"></div>
                  <b-table
                  v-if="!overbookListaEspera"
                    thead-tr-class="columnas"
                    :items="listaPacientes"
                    :fields="encabezados"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    :hover="true"
                    :small="true"
                    @row-clicked="setearPaciente"
                    class="parrafos"
                    responsive
                    fixed
                  >
                    <template v-slot:cell(id)="row">
                      <span>{{ row.item.id }}</span>
                    </template>
                    <template v-slot:cell(name)="row">
                      <div class="spanCien">
                        <span>
                          {{ row.item.esPacienteNuevo ? "*" : ""
                          }}{{ row.item.name }}
                        </span>
                      </div>
                    </template>
                    <template v-slot:cell(saldo)="row">
                      {{ row.item.saldo }}
                    </template>
                    <template v-slot:cell(plan)="row">
                      <span>
                        {{ plan.nombre }}
                      </span>
                    </template>
                  </b-table>
                  <b-pagination
                    v-if="listaPacientes.length > 15"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="listaPacientes.length"
                    :per-page="registrosPorPagina"
                  ></b-pagination>
                </span>
              </b-col>
            </div>
          </b-row>
        </b-container>
      </b-form-group>
    </div>

    <div class="mt-4" v-if="buscarOverbooking">
      <div style="border-style: solid; border-color: #1dbdd5; border-radius: 20px; border-width: 2px; padding: 2%;" v-if="horarioDisponibleOverbooking.length > 0">
        <b-table
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :items="horarioDisponibleOverbooking"
        :fields="fieldsCitas"
      >
        <template #cell(agendar)="row">
          <b-button
            size="sm"
            @click="agendarOverbooking(row.item)"
            class="mr-1"
            variant="outline-primary"
          >
            Agendar
          </b-button>
        </template>
      </b-table>
      </div>
      
      <b-pagination
      class="mt-4"
      v-if="horarioDisponibleOverbooking.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="overbooking"
        align="center"
      ></b-pagination>
    </div>
  </div>
  <b-row>
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
          v-if="!secondReagendar"
      >
        <label>Teléfono</label>
        <validacion />
        <v-select
            label="telefono"
            placeholder="Selecciona un teléfono"
            v-model="datosFormulario.telefono"

        >
              
        </v-select>
      </validation-provider>
    </b-col>
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
          v-if="!secondReagendar"
      >
        <label>Correo</label>
        <validacion />
        <v-select
            label="correo"
            placeholder="Selecciona un correo"
            v-model="datosFormulario.correo"
        >
                <span slot="no-options"
                >No hay correos disponibles</span
                >
        </v-select>
      </validation-provider>
    </b-col>
  </b-row>

  <div class="mt-4">
    <validation-provider
        :rules="{ required: true }"
        v-slot="errors"
    >
      <label>Doctor</label>
      <validacion />
      <b-form-group>
        <v-select
            :options="listaDoctores"
            :filterable="false"
            v-model="datosFormulario.idDoctor"
            :reduce="(variable) => variable.id"
            label="nombre"
            placeholder="Selecciona un doctor (*)"
            @input="llenarEspecialidadesDoctor(true)"
        >
          <span slot="no-options"
            >No hay doctores disponibles</span
          >
        </v-select>
        <validacion
            :texto="errors.errors[0] ? errors.errors[0] : ' '"
        />
      </b-form-group>
    </validation-provider>
  </div>

  <b-row class="mt-4">
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
          v-if="!secondReagendar"
      >
        <label>Especialidad</label>
        <validacion />
        <v-select
            id="idEspecialidad"
            label="nombre"
            placeholder="Selecciona una especialidad"
            :options="listaEspecialidadesDoctor"
            v-model="datosFormulario.idEspecialidad"
            :reduce="(variable) => variable.id"
            @input="llenarTratamientos()"
        >
                <span slot="no-options"
                >No hay especialidad disponibles</span
                >
        </v-select>
      </validation-provider>
    </b-col>
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
          v-if="!secondReagendar"
      >
        <label>Tratamiento</label>
        <validacion />
        <v-select
            id="idTratamiento"
            label="nombre"
            :options="listaTratamientos"
            v-model="datosFormulario.idTratamiento"
            :reduce="(variable) => variable.id"
            placeholder="Selecciona un tratamiento"
        >
                <span slot="no-options"
                >No hay tratamientos disponibles</span
                >
        </v-select>
      </validation-provider>
    </b-col>
  </b-row>

  <b-row class="mt-4">
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Motivo</label>
        <validacion />
        <v-select
            style="width: 100%;  border:2px solid;
              border-color: #aceaf4;
              border-radius: 8px; "
            label="descripcion"
            :options="listaMotivo"
            placeholder="Selecciona un motivo"
            v-model="datosFormulario.idMotivoEspera"
            :reduce="(item) => item.id"
        >
          <span slot="no-options">No hay motivos disponibles</span>
        </v-select>
      </validation-provider>
    </b-col>
   <!--  <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Semaforo</label>
        <validacion />
        <v-select
            style="width: 100%;  border:2px solid;
              border-color: #aceaf4;
              border-radius: 8px; "
            label="descripcion"
            :options="listaSemaforos"
            placeholder="Selecciona un semaforo"
            v-model="datosFormulario.idEstatusListaEspera"
            :reduce="(item) => item.id"
        >
          <template v-slot:option="option">
            <em class="fa fa-circle" :style="{ color: option.data }">
            </em>
            {{ option.descripcion }}
          </template>

          <span slot="no-options">No hay semaforos</span>
        </v-select>
      </validation-provider>
    </b-col> -->
  </b-row>

  <b-row class="mt-4">
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Fecha inicio de cita solicitada</label>
        <validacion />
        <b-form-group>
          <b-spinner small v-if="loadingFechaInicioCitaSoli" />
          <b-form-datepicker
              id="fechacita-datepicker"
              labelNoDateSelected="Fecha inicio de cita solicitada"
              v-model="datosFormulario.fechaInicio"
              range
              class="mb-2"
              :min="fechaMinima"
              in
              no-flip
          ></b-form-datepicker>
          <validacion
              :texto="errors.errors[0] ? errors.errors[0] : ' '"
          />
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Fecha fin de cita Solicitada</label>
        <validacion />
        <b-form-group>
          <b-spinner small v-if="loadingFechaFinCitaSoli" />
          <b-form-datepicker
              id="fechacitafin-datepicker"
              labelNoDateSelected="Fecha fin de cita Solicitada"
              v-model="datosFormulario.fechaFin"
              range
              class="mb-2"
              :min="fechaMinima"
              in
              no-flip
          ></b-form-datepicker>
          <validacion
              :texto="errors.errors[0] ? errors.errors[0] : ' '"
          />
        </b-form-group>
      </validation-provider>
    </b-col>
  </b-row>
  <b-row class="mt-4">
    <b-col class="text-center">
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Fecha fin de cita perdida o cancelada </label>
        <validacion />
        <b-form-group>
          <b-spinner small v-if="loadingFechaFinCitaPerdida" />
          <b-form-datepicker
              id="fechacita-datepicker"
              labelNoDateSelected="Fecha de cita Solicitada"
              range
              class="mb-2"
              :min="fechaMinima"
              in
              no-flip
              v-model="datosFormulario.fechaCitaPerdida"
          ></b-form-datepicker>
          <validacion
              :texto="errors.errors[0] ? errors.errors[0] : ' '"
          />
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col>
      <b-form-group align="left">
        <label>Dias de exclusión:</label>
        <v-select
            style="width: 100%"
            name="dia"
            placeholder="--Seleccionar--"
            label="descripcion"
            multiple
            :options="listaDias"
            :reduce="(variable) => variable.id"
            v-model="datosFormulario.dias"
        ><span slot="no-options">No hay dias disponibles</span>
        </v-select>
      </b-form-group>
      <b-form-invalid-feedback
          :state="datosFormulario.dias!= null && datosFormulario.dias.length > 0"
      >
        Este campo es obligatorio
      </b-form-invalid-feedback>
    </b-col>
  </b-row>
  <b-row class="mt-4 text-center">
    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Hora inicio</label>
        <validacion />
        <b-form-group>
          <vue-timepicker
              id="idHoraInicio"
              v-model="datosFormulario.horaInicio"
              hide-disabled-items
              format="HH:mm"
              :minute-interval="15"
              :hour-range="rangoHoraForm"
              hide-clear-button
          ></vue-timepicker>

          <validacion
              :texto="errors.errors[0] ? errors.errors[0] : ' '"
          />
        </b-form-group>
      </validation-provider>
    </b-col>

    <b-col>
      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Hora fin</label>
        <validacion />
        <b-form-group>
          <vue-timepicker
              id="idHoraFin"
              v-model="datosFormulario.horaFin"
              hide-disabled-items
              format="HH:mm"
              :minute-interval="15"
              :hour-range="rangoHoraForm"
              hide-clear-button
          ></vue-timepicker>

          <validacion
              :texto="errors.errors[0] ? errors.errors[0] : ' '"
          />
        </b-form-group>
      </validation-provider>
    </b-col>
    <b-col cols="12" v-if="rangoHoraClinica !== undefined">
      Horario(s) Clinica:
      <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
          hc
        }}</b-badge>
    </b-col>
    <b-col cols="12" v-else>
      <validacion
          texto="Tu clinica no cuenta con ningún horario"
      />
    </b-col>

    <div>
      <b-col
          cols="12"
          v-if="!rangoHoraFormEsValido"
      >
        <validacion texto="Selecciona un horario válido" />
      </b-col>
    </div>
  </b-row>
  <b-row class="mt-4">
    <b-col>
      <div class="mt-3 col-md-12"></div>

      <validation-provider
          :rules="{ required: true }"
          v-slot="errors"
      >
        <label>Observaciones</label>
        <validacion />
        <b-form-group>
          <b-form-textarea
              id="idObservaciones"
              v-model="datosFormulario.comentario"
              placeholder="Introduce tus observaciones"
              rows="3"
              max-rows="6"
          ></b-form-textarea>
          <validacion
              :texto="errors.errors[0] ? errors.errors[0] : ' '"
          />
        </b-form-group>
      </validation-provider>
    </b-col>
  </b-row>
  
  
  <!-- <EnviarListaEsperaDatosModal @selectPaciente="setearPaciente" @datosFormularioListaEspera="datosFormularioListaEspera = $event"></EnviarListaEsperaDatosModal> -->
    <template v-slot:modal-footer>
      <b-button variant="outline-primary" @click="llenarDatosListaEspera"
      >Aceptar</b-button
      >
      <b-button
          variant="outline-danger"
          @click="showDialogEnviaListEsperaDatos = false; menuDerecha = true"
      >Cancelar
      </b-button>
    </template>
  </b-modal>

    </b-card>
  </div>
</template>

<script>
//components
import Header from "../components/Header.vue";
import miniToastr from "mini-toastr"; //ES6
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
/* import EnviarListaEsperaMotivoModal from "./modalsAgendaInteligente/EnviarListaEsperaMotivo" */
/* import EnviarListaEsperaDatosModal from "./modalsAgendaInteligente/EnviarListaEsperaDatos" */

export default {
  name: "Schedule",
  components: {
    Header,
    vueCustomScrollbar,
    /* EnviarListaEsperaMotivoModal, */
    /* EnviarListaEsperaDatosModal */

  },
  props: {
    msg: String,
  },
  computed: {
    rows() {
      return this.horarioDisponibleOverbooking.length;
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    clinicaEstaSeleccionada() {
      return (
        this.datosBusqueda.clinica.clinicaID !== undefined &&
        this.datosBusqueda.clinica.clinicaID !== null &&
        this.datosBusqueda.clinica.clinicaID > 0
      );
    },
    clinicaId() {
      return this.datosBusqueda.clinica.clinicaID;
    },
    idEspecialidadForm: function () {
      if (this.datosFormulario !== undefined && this.datosFormulario !== null) {
        return this.datosFormulario.idEspecialidad;
      }
      return null;
    },

    obtenerHorarioClinicaForm: function () {
      if (
        this.datosFormulario !== undefined &&
        this.datosFormulario !== null &&
        this.datosFormulario.fechaCita !== undefined &&
        this.datosFormulario.sillon !== undefined
      ) {
        const pos =
          this.$moment(this.datosFormulario.fechaCita).format("YYYY/MM/DD") +
          "-" +
          this.datosFormulario.sillon;
        if (this.horariosClinica[pos] !== undefined) {
          return this.horariosClinica[pos];
        }
      }
      return undefined;
    },
    rangoHoraClinica: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (val !== undefined) {
        return val.original;
      } else {
        return undefined;
      }
    },
    rangoHoraForm: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (val !== undefined) {
        return val.horas;
      } else {
        return [];
      }
    },
    rangoHoraFormEsValido: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (
        val !== undefined &&
        this.datosFormulario.horaInicio.HH !== undefined &&
        this.datosFormulario.horaInicio.mm !== undefined &&
        this.datosFormulario.horaFin.HH !== undefined &&
        this.datosFormulario.horaFin.mm !== undefined
      ) {
        let diaFormato = this.$moment(
          this.datosFormulario.fechaCita,
          "DD/MM/YYYY"
        ).format("YYYY/MM/DD");
        if (!diaFormato._isValid) {
          diaFormato = this.$moment(this.datosFormulario.fechaCita).format(
            "YYYY/MM/DD"
          );
        }

        const horaInicio = this.$moment(
          diaFormato +
            " " +
            this.datosFormulario.horaInicio.HH +
            ":" +
            this.datosFormulario.horaInicio.mm +
            ":00"
        );
        const horaFin = this.$moment(
          diaFormato +
            " " +
            this.datosFormulario.horaFin.HH +
            ":" +
            this.datosFormulario.horaFin.mm +
            ":00"
        );

        if (horaInicio >= horaFin) {
          return false;
        }

        let esValido = false;
        val.horasMinutosDate.forEach((it) => {
          if (horaInicio >= it.horaInicio && horaFin <= it.horaFin) {
            esValido = true;
          }
        });
        return esValido;
      }
      return false;
    },

    getNumeroSillonesClinica: function () {
      return this.calcularNumeroSillones();
    },
    fechaMinima: function () {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    mostrarBusquedaPaciente: function () {
      return (
        this.datosFormulario !== undefined &&
        (this.datosFormulario.idPaciente === undefined ||
          this.datosFormulario.idPaciente < 1)
      );
    },
  },
  watch: {
    // rangoFecha: function (val) {
    //   if (val != null) {
    //     this.diasSemanaSeleccionada(val);
    //   }
    // },
    pacienteSeleccionado: function (val) {
      if (val != null) {
        this.consultarDetallePorPaciente();
      }
    },
    idEspecialidadForm: function () {
      this.llenarTratamientos(this.idEspecialidadForm);
    },
    "datosFormulario.fechaCita": function () {
      this.buscarHorariosClinica();
    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    pacienteBusqueda: [],
    motivoEspera: {
      idPaciente: null,
      idMotivoEspera: null,
      comentario: null
    },
    showDialogEnviaListEspera: false,
    showDialogEnviaListEsperaDatos: false,
    modalAvisoOverbooking: false,
    citasAgendadas: false,
    buscarOverbooking: false,
    overbookListaEspera: false,
    modalFechaOverbooking: false,
    settings: {
      suppressScrollY: false,
      suppressScrollX: false,
      wheelPropagation: false,
    },
    semana: {},
    dias: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    listaMotivo: [],
    loadingFechaFinCitaPerdida:false,
    loadingFechaInicioCitaSoli:false,
    loadingFechaFinCitaSoli:false,
    listaConfirmarCita: null,
    datosFormularioListaEspera: null,
    styleMenu: "fade-in-right sticky-container",
    menuDerecha: true,
    modalsActivos: false,
    third: false,
    showDetail: false,
    guardando: false,
    showAgregarObs: false,
    modalReasignarDoctor: false,
    loading: false,
    loadingCAl: false,
    loadingHorariosClinica: false,
    loadingDoctoresClinica: false,
    loadingDoctoresEsp: false,
    loadingDoctores: false,
    loadingPacientes: false,
    loadingEspecialidadesDoc: false,
    datosBusqueda: {
      tratamientoID: 12,
      clinica: {
        clinicaID: null,
        nombre: "-",
      },
      clinicaNombre: "-",
      fechaInicio: undefined,
      fechaFin: undefined,
      fechaActual: new Date(),
      idEspecialidad: null,
      empleadoId: null,
    },
    datosFormulario: [],
    datosDetalle: [],
    datosFormularioReasignar: [],
    eventos: [],
    eventosSobreAsig: [],
    horariosDoctor: [],
    horariosClinica: [],

    encabezados: [
      {
        key: "id",
        label: "Id",
      },
      {
        key: "name",
        label: "Nombre del Paciente",
      },
    ],
    registrosPorPagina: 15,
    paginaActual: 1,

    // selectedEvent: {},
    splitDays: [],
    events: [], //usado en el calendario miniatura
    clinicSelected: null,
    statusSdi: [],
    second: false,
    secondCitaDesdeCalendario: false,
    secondReagendar: false,

    listaSillones: [],
    listaClinicas: [],
    listaClinicasFiltro: [],
    listaEspecialidades: [],
    listaEspecialidadesDoctor: [],
    listaEspecialidadesDoctorFiltro: [],
    listaTratamientos: [],
    listaTratamientosFiltro: [],
    listaMotivosHerramientas: [],
    listaMotivosHerramientasFiltro: [],
    listaDoctores: [],
    listaDoctoresFiltro: [],
    listaPacientes: [],
    listaMotivosCancelacion: [],
    listaKitsPacienteNuevo: [],
    listaSillonesEmbajador: [],
    listaSillonesEmbajadorFiltro: [],
    listaDias: [],
    idEspecialidadFiltro: null,

    tipoBusqueda: 1,

    tagmotivocitaDatosArray: [],
    tagmotivocitaDatosArrayFiltro: [],
    idCita: null,

    nombrePaciente: null,
    nombreTagMotivoCita: null,
    idTipoDenticion: null,
    nombreTutor: null,
    citaAdministrativa: false,
    citasOv: [],
    selectPaciente: [],
    pacienteSeleccionado: null,
    datosDetalleOriginal: null,
    listaPlanesPaciente: null,
    datosIniciarSesion: {},
    datosCancelarCita: {},
    showDialogIniciarSession: false,
    noExistePTIVigente: false,
    loadingExistePTI: false,
    cargandoKitsCita: false,
    listaKitsCita: [],
    listaKitsCitaFiltro: [],
    listaSINO: [
      {
        etiqueta: "SI",
        valor: true,
      },
      {
        etiqueta: "NO",
        valor: false,
      },
    ],
    listaSINOFiltro: [],
    showDialogConfirmarCita: false,
    showDialogCancelarCita: false,
    showDialogReasignarCita: false,
    fechaLlegada: null,
    isCitaConfirmada: false,
    busquedaOverbooking: false,
    time0: null,
    time1: null,
    time2: null,
    time3: null,
    colorCitaOverbooking: "",
    colorCita: "",
    horarioDisponibleOverbooking: [],
    rangoFecha: null,
    eventosCitas: null,
    semanaActual: "",
    citaIsOverbooking: false,
    fieldsCitas: [
      {
        key: "fechaCitaSinZona",
        label: "Fecha de la cita",
      },
      {
        key: "horaInicioCasilla",
        label: "Hora inicio",
      },
      {
        key: "horaFinCasilla",
        label: "Hora fin",
      },
      {
        key: "sillon",
        label: "Sillón",
      },
      {
        key: "agendar",
        label: "Agendar",
      },
    ],
    encabezadosOverbook: [
      {
        key: "idPaciente",
        label: "ID paciente",
      },
      {
        key: "nombrePaciente",
        label: "Nombre del paciente",
      },
      {
        key: "indicadorProbabilidad",
        label: "Indicador de probabilidad",
      },
      "Porcentaje"
      
    ],
    currentPage: 1,
    perPage: 5,
    posicionPacienteOriginal: null,
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
  }),
  filters: {
    date(date) {
      return new Intl.DateTimeFormat("en-US").format(date);
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.listaSINOFiltro = this.listaSINO;
    this.loading = true;
    if (this.$localStorageService.getIdEmpleado() !== undefined) {
      this.datosBusqueda.clinica.empleadoId =
        this.$localStorageService.getIdEmpleado();
    }
    if (this.$localStorageService.getIdClinica() !== undefined) {
      this.datosBusqueda.clinica.clinicaID =
        this.$localStorageService.getIdClinica();
    }

    this.llenarClinicas();
    this.llenarMotivosHerramientas();
    this.llenarEstatusSDI();
    this.llenarMotivosCancelacion();

    this.listaSillonesEmbajador = [
      { nombre: "E1", valor: 100 },
      { nombre: "E2", valor: 101 },
    ];
    this.listaSillonesEmbajadorFiltro = this.listaSillonesEmbajador;
  },
  methods: {
    llenarDatosEsperaOverbook(){
      let datos = {
        idMotivoEspera: this.motivoEspera.idMotivoEspera,
        idPaciente: this.datosDetalle.idPaciente,
        comentario: this.motivoEspera.comentario,
        fechaFin: new Date(this.datosFormulario.fechaFin), 
        fechaInicio: new Date(this.datosFormulario.fechaInicio), 
        horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
        horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
        idEstatusListaEspera: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEspecialidad: this.datosDetalle.tratamientos[0].idEspecialidad,
        idTratamiento: this.datosDetalle.tratamientos[0].idTratamiento,
        diasExclusion: this.datosFormulario.dias,
      };

      this.guardarListaEsperaDatos(datos);
    },

    llenarDatosListaEspera(){
      let datos = {
        idMotivoEspera: this.datosFormulario.idMotivoEspera,
        idPaciente: this.datosFormulario.idPaciente,
        comentario: this.datosFormulario.comentario,
        fechaFin: new Date(this.datosFormulario.fechaFin), 
        fechaInicio: new Date(this.datosFormulario.fechaInicio), 
        horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
        horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
        idEstatusListaEspera: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEspecialidad: this.datosFormulario.idEspecialidad,
        idTratamiento: this.datosFormulario.idTratamiento,
        diasExclusion: this.datosFormulario.dias,
      };

      this.guardarListaEsperaDatos(datos);
    },

    enviarListaEspera(){
      this.obtenerDias();
      this.mostrarModalCrearCita(false);
      /* this.showDialogEnviaListEsperaDatos = true; */
      const today = this.$moment();
      const year = today.format("YYYY");

      var weeknumber = this.$moment(today, "MM-DD-YYYY").week();

      this.semanaActual = year + "-W" + weeknumber;
      this.rangoFecha = this.semanaActual;
      this.menuDerecha = false;
      this.showDialogEnviaListEspera=true;
      this.traerMotivoEspera();
    },
    traerMotivoEspera() {
      const url = this.$api + "catalogos/obtenerMotivosEspera";
      this.$http
          .get(url)
          .then((response) => {
            this.listaMotivo = response.data.data;
          })
          .catch((err) => {
            this.mostrarError(err);
          });
    },
    obtenerDias(){
      this.$http
          .get(this.$api + "catalogos/obtenerDias")
          .then((response) => {
            if (response.status === 200) {
              this.listaDias= response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    activarModalEspera(){
      this.obtenerDias();
      this.overbookListaEspera = false;
      this.mostrarModalCrearCita(false);
      this.horarioDisponibleOverbooking = [];

      this.traerMotivoEspera();

      this.showDialogEnviaListEsperaDatos = true;
      const today = this.$moment();
      const year = today.format("YYYY");

      var weeknumber = this.$moment(today, "MM-DD-YYYY").week();

      this.semanaActual = year + "-W" + weeknumber;
      this.rangoFecha = this.semanaActual;
      this.menuDerecha = false;
    },

    guardarListaEsperaDatos(datos) {


this.$http
    .post(
        this.$api +
        "agendaclinica/listaEspera/guardar", datos
    )
    .then(() => {
      this.$swal.fire({
        icon: "success",
        title: "Aviso",
        text: "Se agregó a la lista de espera de manera éxitosa",
      });
      /* this.showDialogEnviaListEsperaDatos = false; */
    })
    .catch((error) => {
      console.error("Error", error);
      this.$swal.fire({
        icon: "error",
        title: "Aviso",
        text: "Ocurrió un error al enviar a la lista de espera",
      });
    });
},
    cerrarOverbooking(){
      this.busquedaOverbooking = false;
      this.datosFormulario = [];
      this.buscarOverbooking = false;
      this.menuDerecha = true;

    },
    activarListaEspera(paciente){
      this.$swal({
        icon: "warning",
        text: "Antes de enviar a lista de espera, se deberá verificar Overbooking, ¿desea continuar?",
        title: "Lista de espera",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(() => {
        this.datosFormulario.nombrePacienteBusqueda = paciente.nombrePaciente;
        this.tipoBusqueda = 1;
        this.datosFormulario.idDoctor = paciente.idDoctor;
        this.datosFormulario.nombreDoctor = paciente.nombreDoctor
        
        this.datosFormulario.idEspecialidad = paciente.tratamientos[0].idEspecialidad
        this.llenarDoctoresEmbajadorClinica(
          this.datosBusqueda.clinica.clinicaID
        );
      
        this.datosFormulario.nombrePaciente = paciente.nombrePaciente
        this.datosFormulario.idPaciente = paciente.idPaciente
        this.llenarEspecialidadesDoctor(false);
        this.tagMotivoCita();
        this.busquedaOverbooking = true;
        this.overbookListaEspera = true;
      });

    },
    obtenerSemana() {
      let fecha = new Date();
      fecha = new Date(this.datosBusqueda.fechaInicio.toISOString());
      const mesSemana = this.$moment(fecha.toISOString()).format("MMMM YYYY");
      this.semana.numeroSemana =
        "Semana " +
        this.$moment(fecha.toISOString()).week() +
        " (" +
        mesSemana.charAt(0).toUpperCase() +
        mesSemana.slice(1) +
        ")";
    },
    cambiarAnteriorSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      fecha.setDate(fecha.getDate() - 7);
      this.seleccionarFecha(fecha);
    },

    cambiarSiguienteSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      fecha.setDate(fecha.getDate() + 7);
      this.seleccionarFecha(fecha);
    },
    filtroSillonesEmbajador(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaSillonesEmbajadorFiltro = this.listaSillonesEmbajador.filter(
        (em) => {
          return em.nombre.toLowerCase().includes(seach.toLowerCase());
        }
      );
      loading(false);
    },
    filtrolListaKitsCitaFiltro(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaKitsCitaFiltro = this.listaKitsCita.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtrolListaMotivosHerramientas(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaMotivosHerramientasFiltro =
        this.listaMotivosHerramientasFiltro.filter((em) => {
          return em.nombre.toLowerCase().includes(seach.toLowerCase());
        });
      loading(false);
    },
    filtrolListaSINO(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaSINOFiltro = this.listaSINO.filter((em) => {
        return em.etiqueta.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtroTratamientos(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaTratamientosFiltro = this.listaTratamientos.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtroEspecialidadesDoctor(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaEspecialidadesDoctorFiltro =
        this.listaEspecialidadesDoctor.filter((em) => {
          return em.nombre.toLowerCase().includes(seach.toLowerCase());
        });
      loading(false);
    },
    filtroDoctores(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaDoctoresFiltro = this.listaDoctores.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtrotagmotivocitaDatos(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.tagmotivocitaDatosArrayFiltro = this.tagmotivocitaDatosArray.filter(
        (em) => {
          return em.descripcionTagMotivoCita
            .toLowerCase()
            .includes(seach.toLowerCase());
        }
      );
      loading(false);
    },
    filtroClinicas(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaClinicasFiltro = this.listaClinicas.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    cambioPacienteSeleccionado(paciente) {
      this.pacienteSeleccionado = paciente;
    },
    changeFormat: function (args) {
      this.dateFormat = args.value;
      this.separate = args.value === "yyyy/MM/dd HH:mm" ? "to" : "-";
    },
    activarModalOverbooking() {
      this.overbookListaEspera = false;
      this.mostrarModalCrearCita(false);
      this.horarioDisponibleOverbooking = [];
      this.busquedaOverbooking = true;
      const today = this.$moment();
      const year = today.format("YYYY");

      var weeknumber = this.$moment(today, "MM-DD-YYYY").week();

      this.semanaActual = year + "-W" + weeknumber;
      this.rangoFecha = this.semanaActual;
      this.menuDerecha = false;
    },

    agendarOverbooking(datosCita) {
      this.datosFormulario = datosCita;
      this.citaIsOverbooking = true;
      this.second = true;
    },

    verificarOverbooking() {
      this.loading = true;
      let fecha = this.$moment(this.datosFormulario.fechaCita).format(
        "YYYY-MM-DD[T]HH:mm[:00Z]"
      );

      const datosGuardar = {
        especialidad: this.datosFormulario.idEspecialidad,
        empleado: this.datosFormulario.idDoctor,
        fecha: fecha,
      };
      let idPacienteAgendar = this.datosFormulario.idPaciente;
      let citas = [];

      this.$http
        .post(
          this.$api +
            "cita/citasOverBook?idPacienteAgendar=" +
            idPacienteAgendar,
          datosGuardar
        )
        .then((response) => {
          citas = response.data.data;
          if (response.status === 200) {
            this.horarioDisponibleOverbooking = response.data.data.map((it) => {
              var horarioInicio = it.hora_inicio.toString();
              var horarioFin = it.hora_fin.toString();
              if (horarioInicio.length == 3) {
                horarioInicio = "0" + horarioInicio;
              }
              if (horarioFin.length == 3) {
                horarioFin = "0" + horarioFin;
              }
              let horaInicio = horarioInicio.substring(0, 2);
              let minutosInicio = horarioInicio.substring(2, 4);
              let horaFin = horarioFin.substring(0, 2);
              let minutosFin = horarioFin.substring(2, 4);
              let fechaSinZona = it.fecha.substring(0, 10);
              return {
                fechaCita: it.fecha,
                fechaCitaSinZona: fechaSinZona,
                horaInicioCasilla: horaInicio + ":" + minutosInicio,
                horaFinCasilla: horaFin + ":" + minutosFin,
                sillon: it.sillon,
                agendar: "agendar",
                idEspecialidad: it.idespecialidad,
                idDoctor: it.idempleado,
                idPaciente: this.datosFormulario.idPaciente,
                nombrePaciente: this.datosFormulario.nombrePaciente,
                idClinica: citas.idClinica,
                idCanalOrigen: 1,
                idCompania: 1,
                horaInicio: {
                  HH: horaInicio,
                  mm: minutosInicio,
                },
                horaFin: {
                  HH: horaFin,
                  mm: minutosFin,
                },
              };
            });
            if (this.horarioDisponibleOverbooking.length === 0) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "No se encontraron citas para hacer overbooking",
                confirmButtonColor: "#0e6ba9",
                confirmButtonText: "OK",
              });
            }
            this.actualizarNombreClinica(true);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error) {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "No se encontraron citas para hacer overbooking",
              confirmButtonColor: "#0e6ba9",
              confirmButtonText: "OK",
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.buscarOverbooking = true;
        });
    },
    activarReasignarDoctor(cita) {
      const activar =
        cita !== undefined &&
        cita !== null &&
        cita.idEstatusCita !== undefined &&
        cita.idEstatusCita !== null &&
        (cita.idEstatusCita === 5 ||
          cita.idEstatusCita === 11 ||
          cita.idEstatusCita === 24 ||
          cita.idEstatusCita === 26) &&
        this.$localStorageService.can("RD_01_reagendar_og");

      return (
        activar &&
        (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
          this.$moment() ||
          this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
            this.$moment())
      );
    },
    activarReagendar(cita) {
      const activar =
        cita !== undefined &&
        cita !== null &&
        cita.idEstatusCita !== undefined &&
        cita.idEstatusCita !== null &&
        (cita.idEstatusCita === 5 ||
          cita.idEstatusCita === 11 ||
          cita.idEstatusCita === 24 ||
          cita.idEstatusCita === 26) &&
        this.$localStorageService.can("CA_06_reagendar_cita");

      return (
        activar &&
        (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
          this.$moment() ||
          this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
            this.$moment())
      );
    },
    activarCancelarCita(cita) {
      const activar =
        cita !== undefined &&
        cita !== null &&
        cita.idEstatusCita !== undefined &&
        cita.idEstatusCita !== null &&
        (cita.idEstatusCita === 5 ||
          cita.idEstatusCita === 11 ||
          cita.idEstatusCita === 24 ||
          cita.idEstatusCita === 26) &&
        this.$localStorageService.can("CA_06_cancelar_cita");

      return (
        activar &&
        (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
          this.$moment() ||
          this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
            this.$moment())
      );
    },
    activarConfirmarCita(cita) {
      const activar =
        cita !== undefined &&
        cita !== null &&
        cita.idEstatusCita !== undefined &&
        cita.idEstatusCita !== null &&
        (cita.idEstatusCita === 5 ||
          cita.idEstatusCita === 11 ||
          cita.idEstatusCita === 24 ||
          cita.idEstatusCita === 26) &&
        this.$localStorageService.can("CA_06_confirmar_cita");

      return (
        activar &&
        (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
          this.$moment() ||
          this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
            this.$moment())
      );
    },
    iniciarSesionServ() {
      this.showDialogIniciarSession = false;
      this.datosIniciarSesion.citaSeleccionada = this.citaSeleccionada;
      this.iniciarSesion2();
    },
    submitIniciarSesion() {
      this.$refs.submitIniciarSesion.click();
    },
    onClick(text) {
      alert(`You clicked ${text}!`);
    },
    activarIniciarSesion(cita) {
      if (cita != null) {
        const activar =
          cita !== undefined &&
          cita !== null &&
          cita.idEstatusCita !== undefined &&
          cita.idEstatusCita !== null &&
          (cita.idEstatusCita === 5 ||
            cita.idEstatusCita === 11 ||
            cita.idEstatusCita === 24 ||
            cita.idEstatusCita === 26) &&
          this.$localStorageService.can("CA_6_iniciar_sesion");

        return (
          activar &&
          this.$moment(
            cita.fechaCitaSinZona + " " + cita.horaInicioCasilla
          ).format("YYYY-MM-DD") === this.$moment().format("YYYY-MM-DD")
        );
      }
    },
    llenarMotivosCancelacion() {
      this.listaMotivosCancelacion = [];
      this.$http
        .get(this.$api + "catalogos/obtenerMotivosCancelacion")
        .then((response) => {
          if (response.status === 200) {
            this.listaMotivosCancelacion = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    llenarEstatusSDI() {
      this.$http
        .get(this.$api + "catalogos/obtenerEstatusPacienteSDI")
        .then((response) => {
          if (response.data.data) {
            this.statusSdi = response.data.data;
          }
        });
    },
    llenarClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((response) => {
          if (response.status === 200) {
            this.listaClinicas = response.data.data
              .map((it) => {
                return {
                  id: it.idClinica,
                  nombre: it.strNombre,
                  numeroSillones: it.numeroSillones,
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            this.listaClinicasFiltro = this.listaClinicas;
            this.actualizarNombreClinica(true);
          }
        })
        .catch((error) => {
          this.listaClinicas = Array();
          console.error(error);
        })
        .finally(() => {
          this.llenarPacientesClinica();
        });
    },
    calcularNumeroSillones() {
      this.sillonesSelec = [];
      if (
        this.datosBusqueda.clinica !== null &&
        this.datosBusqueda.clinica.clinicaID !== undefined &&
        this.datosBusqueda.clinica.clinicaID > 0 &&
        this.listaClinicas !== undefined &&
        this.listaClinicas !== null
      ) {
        const clinica = this.listaClinicas.find(
          (c) => c.id === this.datosBusqueda.clinica.clinicaID
        );
        if (clinica !== undefined) {
          const sillones = this.listaClinicas.find(
            (c) => c.id === this.datosBusqueda.clinica.clinicaID
          ).numeroSillones;
          if (sillones !== undefined && sillones !== null && sillones > 0) {
            this.listaSillones = Array.from({length: sillones}, (_, i) => i + 1);
            return sillones;
          }
        }
      }
      return 1;
    },
    llenarTratamientos(idEspecialidad) {
      if (
        idEspecialidad === undefined ||
        idEspecialidad === null ||
        idEspecialidad === 0
      ) {
        this.listaTratamientos = Array();
        return;
      }

      const listaEspecialidades = [idEspecialidad];
      const params = {
        idClinica: this.datosBusqueda.clinica.clinicaID,
        idsEspecialidad: listaEspecialidades
      }

      this.$http
        .put(
          this.$api +
            "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidad", 
            params  )
        .then((response) => {
          if (response.status === 200) {
            this.listaTratamientos = response.data.data
              .map((it) => {
                return {
                  id: it.idTratamiento,
                  nombre: it.nombre,
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            this.listaTratamientosFiltro = this.listaTratamientos;
          }
        })
        .catch((error) => {
          console.error("error del methos tratamientos", error);
        });
    },
    llenarMotivosHerramientas() {
      this.$http
        .get(this.$api + "catalogos/listaMotivosHerramientas")
        .then((response) => {
          if (response.status === 200) {
            this.listaMotivosHerramientas = response.data.data
              .map((it) => {
                return {
                  id: it.idMotivo,
                  nombre: it.descripcion,
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            this.listaMotivosHerramientasFiltro = this.listaMotivosHerramientas;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async llenarDoctoresEspecialistasClinica(idClinica) {
      this.loadingDoctoresClinica = true;
      this.loadingDoctoresEsp = true;
      this.listaDoctores = [];

      if (
        this.datosFormulario.idPaciente === undefined ||
        this.datosFormulario.idPaciente == null ||
        this.datosFormulario.idPaciente === 0
      ) {
        return;
      }

      const parametros = {
        idClinica: idClinica,
        idPaciente: this.datosFormulario.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "diagnostico/hoja/obtenerDoctoresClinicaPaciente", parametros
        )
        .then((response) => {
          this.listaDoctores.push(
            ...response.data.data
              .map((it) => {
                return {
                  id: it.idEmpleado,
                  nombre:
                    it.numeroEmpleado +
                    " " +
                    it.nombreEmpleado +
                    " (" +
                    this.obtenerEspecialidadesDoctor(it) +
                    ")",
                  especialidades: it.especialidades,
                };
              })
              .filter(
                (x) =>
                  x.especialidades !== undefined &&
                  x.especialidades.some((it00) => it00.idEspecialidad > 1)
              )
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
          );
          this.listaDoctoresFiltro = this.listaDoctores;

          const parametros = {idClinica: idClinica}
          this.$http
            .post(
              this.$api +
                "diagnostico/hoja/listaDoctoresEspecialistas", parametros
            )
            .then((response) => {
              const empleadosEsp = response.data.data
                .map((it) => {
                  return {
                    id: it.idEmpleado,
                    nombre:
                      it.numeroEmpleado +
                      " " +
                      it.nombreEmpleado +
                      " (" +
                      it.nombreEspecialidades +
                      ")",
                  };
                })
                .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);

              this.listaDoctores.push(
                ...empleadosEsp.filter((it) => {
                  let existe = !this.listaDoctores.some(
                    (itSome) => itSome.id === it.id
                  );
                  return existe;
                })
              );
              this.listaDoctoresFiltro = this.listaDoctores;
            })
            .catch((error) => {
              this.loadingDoctoresEsp = false;
              console.error(error);
            })
            .finally(() => (this.loadingDoctoresEsp = false));
        })
        .catch((error) => {
          this.loadingDoctoresClinica = false;
          console.error(error);
        })
        .finally(() => {
          this.loadingDoctoresClinica = false;
        });
    },
    async llenarDoctoresClinica(idClinica) {
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        this.listaDoctores = Array();
        return;
      }

      if (
        this.datosFormulario.idPaciente === undefined ||
        this.datosFormulario.idPaciente == null ||
        this.datosFormulario.idPaciente === 0
      ) {
        return;
      }

      this.loadingDoctoresClinica = true;
      const parametros = {
        idClinica: idClinica,
        idPaciente: this.datosFormulario.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "diagnostico/hoja/obtenerDoctoresClinicaPaciente", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.listaDoctores = response.data.data
              .map((it) => {
                return {
                  id: it.idEmpleado,
                  nombre:
                    it.numeroEmpleado +
                    " " +
                    it.nombreEmpleado +
                    " (" +
                    this.obtenerEspecialidadesDoctor(it) +
                    ")",
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            this.listaDoctoresFiltro = this.listaDoctores;
          }
        })
        .catch((error) => {
          this.loadingDoctoresClinica = false;
          console.error(error);
        })
        .finally(() => {
          this.loadingDoctoresClinica = false;
        });
    },
    async llenarDoctoresEmbajadorClinica(idClinica) {
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        this.listaDoctores = Array();
        return;
      }
      this.loadingDoctores = true;
      const parametros = {idClinica: idClinica}
      this.$http
        .post(
          this.$api +
            "diagnostico/hoja/obtenerListaDoctoresEmbajadorClinica", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.listaDoctores = response.data.data
              .map((it) => {
                return {
                  id: it.idEmpleado,
                  nombre:
                    it.numeroEmpleado +
                    " " +
                    it.nombreEmpleado +
                    " (" +
                    this.obtenerEspecialidadesDoctor(it) +
                    ")",
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            this.listaDoctoresFiltro = this.listaDoctores;
          }
        })
        .catch((error) => {
          this.loadingDoctores = false;
          console.error(error);
        })
        .finally(() => (this.loadingDoctores = false));
    },
    llenarEspecialidadesDoctor(limpiarEspecialidad) {
      this.listaEspecialidadesDoctor = Array();
      if (
        this.datosFormulario === undefined ||
        this.datosFormulario.idDoctor === undefined ||
        this.datosFormulario.idDoctor === null ||
        this.datosFormulario.idDoctor === 0
      ) {
        return;
      }

      if (limpiarEspecialidad) {
        this.datosFormulario.idEspecialidad = null;

        if (!this.datosFormulario.esPacienteNuevo) {
          this.datosFormulario.idTratamiento = null;
        }
      }

      this.loadingEspecialidadesDoc = true;
      const parametros = {idEmpleado: this.datosFormulario.idDoctor}
      this.$http
        .post(
          this.$api +
            "colaboradores/obtenerEspecialidadesDoctor", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.listaEspecialidadesDoctor = response.data.data
              .map((it) => {
                return {
                  id: it.idEspecialidad,
                  nombre: it.nombreEspecialidad,
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            this.listaEspecialidadesDoctorFiltro =
              this.listaEspecialidadesDoctor;
          }
        })
        .catch((error) => {
          this.loadingEspecialidadesDoc = false;
          console.error(error);
        })
        .finally(() => {
          this.loadingEspecialidadesDoc = false;
          return this.listaEspecialidadesDoctor;
        });
    },
    llenarPacientesClinica() {
      this.listaPacientes = Array();
      this.paginaActual = 1;
      if (
        this.datosFormulario === undefined ||
        this.datosFormulario.nombrePacienteBusqueda === undefined ||
        this.datosFormulario.nombrePacienteBusqueda === null ||
        this.datosFormulario.nombrePacienteBusqueda.length < 4
      ) {
        return;
      }

      const inputTxt = this.datosFormulario.nombrePacienteBusqueda
        .trim()
        .toLowerCase()
        .toUpperCase();

      this.loadingPacientes = true;
      const params = {
        nombrePaciente: inputTxt,
        tipoBusqueda: this.tipoBusqueda
      }
      this.$http
        .post(
          this.$api +
            "paciente/perfiles/obtenerDatosPacientePorOpcionBusqueda",
            params
        )
        .then((response) => {
          if (response.status === 200) {
            
            
            if (Array.isArray(response.data.data)) {
              const uniqueAddresses = Array.from(
                new Set(response.data.data.map((a) => a.id))
              ).map((id) => {
                return response.data.data.find((a) => a.id === id);
              });
              uniqueAddresses.map((elementDos) => {
                
                var data = {
                  id: elementDos.id,
                  name: elementDos.nombre,
                  esPacienteNuevo: elementDos.esPacienteNuevo,
                  indicadorProbabilidad: elementDos.indicadorProbabilidad,
                  correo: elementDos.correo,
                  telefono: elementDos.telefono
                };
                this.listaPacientes.push(data);
                return data;
              });

              if (Array.isArray(this.listaPacientes)) {
                this.listaPacientes.sort(function (a, b) {
                  if (a.id > b.id) {
                    return 1;
                  }
                  if (a.id < b.id) {
                    return -1;
                  }
                  return 0;
                });
              }
            }
          }
        })
        .catch((error) => {
          miniToastr.info("No se encontraron pacientes");
          console.error("Error", error);
          this.loadingPacientes = false;
        })
        .finally(() => {
          this.loadingPacientes = false;
        });
        return this.listaPacientes;
    },

    getPatientsV2() {
      if ( (this.nombre != undefined && this.nombre.length >= 3) || (this.apellidoPaterno != undefined && this.apellidoPaterno.length >= 3) || (this.apellidoMaterno != undefined && this.apellidoMaterno.length >= 3)) {

        this.loadingPacientes = true;
        this.$http
            .get(
                this.$api +
                "paciente/perfiles/obtenerDatosPacienteAgenda?nombre=" +
                this.nombre.trim() + "&apellidoPaterno=" + this.apellidoPaterno.trim() + "&apellidoMaterno=" + this.apellidoMaterno.trim()
            )
            .then((response) => {
              if (response.status === 200) {


                if (Array.isArray(response.data.data)) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.id))
                  ).map((id) => {
                    return response.data.data.find((a) => a.id === id);
                  });
                  uniqueAddresses.map((elementDos) => {

                    var data = {
                      id: elementDos.id,
                      name: elementDos.nombre,
                      esPacienteNuevo: elementDos.esPacienteNuevo,
                      indicadorProbabilidad: elementDos.indicadorProbabilidad,
                      correo: elementDos.correo,
                      telefono: elementDos.telefono
                    };
                    this.listaPacientes.push(data);
                    return data;
                  });

                  if (Array.isArray(this.listaPacientes)) {
                    this.listaPacientes.sort(function (a, b) {
                      if (a.id > b.id) {
                        return 1;
                      }
                      if (a.id < b.id) {
                        return -1;
                      }
                      return 0;
                    });
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              console.error("Error", error);
              this.loadingPacientes = false;
            })
            .finally(() => {
              this.loadingPacientes = false;
            });
        return this.listaPacientes;
      }
    },

    limpiarPacienteSeleccionado() {
      this.datosFormulario.idPaciente = null;
      this.datosFormulario.nombrePaciente = null;
      this.datosFormulario.nombrePacienteBusqueda = null;
      this.listaPacientes = Array();
    },

    async buscarAgenda() {
      this.eventos = Array();
      this.eventosSobreAsig = Array();
      this.horariosDoctor = [];
      this.listaEspecialidades = [
        {
          id: null,
          nombre: "Todos",
          color: "white",
        },
      ];

      const idClinica = this.datosBusqueda.clinica.clinicaID;
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        return;
      }

      this.loading = true;
      this.loadingCAl = false;

      const clinicaID = this.datosBusqueda.clinica.clinicaID;
      const fechaInicio = 
        this.$moment(this.datosBusqueda.fechaInicio)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      const fechaFin =
        this.$moment(this.datosBusqueda.fechaFin)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      const parametros = {
        idClinica: clinicaID,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin
      }
      this.$http
        .post(
          this.$api +
            "agenda/obtenerCitasClinica", parametros
        )
        .then((response) => {
          if (response.status === 200 && response.data.data !== undefined) {
            this.procesarBusquedaAgenda(response);
          }
        })
        .catch((error) => {
          console.error("No hay datos" + error);
          this.loading = false;
          this.loadingCAl = false;
        });
    },

    async procesarBusquedaAgenda(response) {
      this.eventos = [];
      await this.procesarCitasClinica(response);
      await this.procesarHorariosDoctorClinica(response);
      await this.procesarHorariosBloqueados(response);
      this.loadingCAl = false;
      if (this.$refs.calDentalia !== undefined) {
        await this.$refs.calDentalia.calcularSemana(
          this.datosBusqueda.fechaInicio,
          this.eventos,
          this.horariosDoctor,
          this.getNumeroSillonesClinica
        );
        this.eventosCitas = this.eventos;
        this.obtenerSemana();
      }
      this.loading = false;
    },
    async procesarCitasClinica(response) {
      if (
        response.data.data.citas !== undefined &&
        response.data.data.citas !== null
      ) {
        response.data.data.citas.forEach((v) => {
          v.horaInicio = v.horaInicio.toString();
          if (v.horaInicio.length < 4) {
            v.horaInicio = "0" + v.horaInicio;
          }

          v.horaFin = v.horaFin.toString();
          if (v.horaFin.length < 4) {
            v.horaFin = "0" + v.horaFin;
          }

          if (v.horaInicio.toString().length === 4) {
            v.horaInicioCasilla =
              v.horaInicio.substr(0, 2) + ":" + v.horaInicio.substr(2, 3);
          }
          if (v.horaFin.toString().length === 4) {
            v.horaFinCasilla =
              v.horaFin.substr(0, 2) + ":" + v.horaFin.substr(2, 3);
          }

          v.especialistaNino = false;
          if (
            v.idEspecialidadDoctor !== undefined &&
            v.idEspecialidadDoctor !== null
          ) {
            try {
              const especiDoc = v.idEspecialidadDoctor.split(",").map(Number);
              v.especialistaNino = especiDoc.indexOf(3) > -1;
            } catch (e) {
              console.error(e);
            }
          }

          const fechaEvento = this.$moment(v.fechaCitaSinZona).format(
            "YYYY/MM/DD"
          );
          v.fechaCita = this.$moment(v.fechaCitaSinZona);

          const sillon = v.sillon;

          const pos = fechaEvento + "-" + v.horaInicio + "-" + sillon;

          v.titleDebug = "";
          if (this.$debug && v.idCita == 210000236) {
            v.titleDebug =
              "ID:" +
              v.idCita.idCita +
              " - estatus:" +
              v.idCita.idEstatusCita +
              v.idCita.notacionCanalOrigen +
              " " +
              (v.idCita.siglasAseguradora !== undefined &&
              v.idCita.siglasAseguradora !== null &&
              v.idCita.siglasAseguradora.length > 0
                ? v.idCita.siglasAseguradora
                : "") +
              " Pac: " +
              v.idCita.idPaciente +
              "-" +
              v.idCita.nombrePaciente +
              " Doc: " +
              v.idCita.idDoctor +
              "-" +
              v.idCita.nombreDoctor +
              " Sillón: " +
              v.idCita.sillon +
              " Fecha: " +
              this.$formatoFecha(v.idCita.fechaCita) +
              " Horario: " +
              this.$formatoHoraDeHora(v.idCita.horaInicioCasilla) +
              " a " +
              this.$formatoHoraDeHora(v.idCita.horaFinCasilla);

          }

          v.inicialesDoctor = this.$iniciales(v.nombreDoctor);

          v.mostrarSiglasAseguradora =
            v.siglasAseguradora !== undefined &&
            v.siglasAseguradora !== null &&
            v.siglasAseguradora.length > 0;

          if (v.motivoCitaTag !== undefined) {
            v.citaUrgencia = v.motivoCitaTag === "DOLOR/URGENCIA";
          }

          v = this.calcularTamaniosColoresCita(v);

          let citaParaCasilla = JSON.parse(JSON.stringify(v));

          let datosCasilla = this.eventos[pos];

          if (datosCasilla === undefined || datosCasilla === null) {
            datosCasilla = {
              style: citaParaCasilla.style,
              ancho: citaParaCasilla.ancho,
              tamanioN: citaParaCasilla.tamanioN,
              titleDebug: citaParaCasilla.titleDebug,
              colorEstatusSDI: citaParaCasilla.colorEstatusSDI,
              citaUrgencia: citaParaCasilla.citaUrgencia,
              notacionCanalOrigen: citaParaCasilla.notacionCanalOrigen,
              inicialesDoctor: citaParaCasilla.inicialesDoctor,
              lstImagenes: citaParaCasilla.lstImagenes,
              mostrarSiglasAseguradora:
                citaParaCasilla.mostrarSiglasAseguradora,
              siglasAseguradora: citaParaCasilla.siglasAseguradora,
              citas: [citaParaCasilla],
              citaSize: null,
            };
            datosCasilla.citas.push(citaParaCasilla);
            let duplicados = [];

            const tempArray = [...datosCasilla.citas].sort();

            for (let i = 0; i < tempArray.length; i++) {
              if (tempArray[i + 1] === tempArray[i]) {
                duplicados.push(tempArray[i]);
                let repetido = datosCasilla.citas.indexOf(tempArray[i]);
                datosCasilla.citas.splice(repetido, 1);
              }
            }
          } else {
            datosCasilla.colorEstatusSDI = undefined; //quitamos el color del copete cuando hay mas citas
            datosCasilla.notacionCanalOrigen +=
              "/" + citaParaCasilla.notacionCanalOrigen;
            datosCasilla.inicialesDoctor +=
              "/" + citaParaCasilla.inicialesDoctor;
            datosCasilla.siglasAseguradora +=
              "/" + citaParaCasilla.siglasAseguradora;

            if (datosCasilla.lstImagenes === null) {
              datosCasilla.lstImagenes = [];
            }
            datosCasilla.lstImagenes = datosCasilla.lstImagenes.concat(
              citaParaCasilla.lstImagenes
            );
            datosCasilla.lstImagenes = datosCasilla.lstImagenes.filter(
              (valor, indice) => {
                return datosCasilla.lstImagenes.indexOf(valor) === indice;
              }
            );

            datosCasilla.citaUrgencia =
              datosCasilla.citaUrgencia ||
              (!datosCasilla.citaUrgencia && citaParaCasilla.citaUrgencia);

            datosCasilla.mostrarSiglasAseguradora =
              datosCasilla.mostrarSiglasAseguradora ||
              (!datosCasilla.mostrarSiglasAseguradora &&
                citaParaCasilla.mostrarSiglasAseguradora);

            datosCasilla.citas.push(citaParaCasilla);

            let duplicados = [];

            const tempArray = [...datosCasilla.citas].sort();

            for (let i = 0; i < tempArray.length; i++) {
              if (tempArray[i + 1] === tempArray[i]) {
                duplicados.push(tempArray[i]);
                let repetido = datosCasilla.citas.indexOf(tempArray[i]);
                datosCasilla.citas.splice(repetido, 1);
              }
            }

            datosCasilla.citaSize = datosCasilla.citas.length;
            datosCasilla = this.calcularTamaniosColoresCitaMulti(datosCasilla);
          }

          this.eventos[pos] = datosCasilla;
        });
        return this.eventos;
      }
      return true;
    },
    calcularTamaniosColoresCita(cita) {
      cita.color = "background: rgb(255, 102, 0);";
      this.colorCita = "(255, 102, 0)";
      cita.tamanio = "height: 26.75px;";
      cita.tamanioN = 26.75;

      const fc1 = new Date("2014-02-27T" + cita.horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + cita.horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      const tamanio = 26.75 * vecesRepetir;
      cita.tamanioN = tamanio;

      cita.tamanio = "height: " + tamanio + "px;";

      if (Number(cita.idEstatusCita) === 11) {
        cita.color = "background: rgb(208, 38, 38);";
        this.colorCita = "(208, 38, 38)";
      } else if (Number(cita.idEstatusCita) === 12) {
        cita.color = "background: rgb(52, 141, 0);";
        this.colorCita = "(208, 38, 38)";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        cita.ancho = "width:20px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        cita.ancho = "width:" + 20 / num + "px;";
      } else {
        cita.ancho = "width:" + 80 / num + "px; color:black;";
      }

      cita.style = cita.ancho + cita.color + cita.tamanio;

      if (this.$debug) {
        cita.titleDebug =
          cita.titleDebug +
          "  Color:" +
          cita.color +
          "  Tamanio:" +
          cita.tamanio +
          "  Ancho:" +
          cita.ancho;
      }

      return cita;
    },

    calcularTamaniosColoresCitaMulti(datosCasilla) {
      let confirmados = 0;
      let asistidos = 0;
      let horaInicioCasilla = datosCasilla.citas[0].horaInicioCasilla;
      let horaFinCasilla = datosCasilla.citas[0].horaFinCasilla;
      datosCasilla.citas.forEach((it) => {
        if (it.horaInicioCasilla < horaInicioCasilla) {
          horaInicioCasilla = it.horaInicioCasilla;
        }

        if (it.horaFinCasilla > horaFinCasilla) {
          horaFinCasilla = it.horaFinCasilla;
        }

        if (Number(it.idEstatusCita) === 11) {
          confirmados++;
        } else if (Number(it.idEstatusCita) === 12) {
          asistidos++;
        }
      });

      const fc1 = new Date("2014-02-27T" + horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      datosCasilla.tamanioN = 26.75 * vecesRepetir;
      const tamanio = "height: " + datosCasilla.tamanioN + "px;";

      let color = "background:rgb(202, 225, 82);";
      if (confirmados === datosCasilla.citaSize) {
        color = "background: rgb(208, 38, 38);";
      } else if (asistidos === datosCasilla.citaSize) {
        color = "background: rgb(52, 141, 0);";
      } else if (confirmados > 0 && asistidos > 0) {
        color = "background: rgb(244, 142, 52);";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        datosCasilla.ancho = "width:20px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        datosCasilla.ancho = "width:" + 20 / num + "px;";
      } else {
        datosCasilla.ancho = "width:" + 80 / num + "px; color:black;";
      }

      datosCasilla.style = datosCasilla.ancho + color + tamanio;

      if (this.$debug) {
        datosCasilla.titleDebug =
          "  Color:" +
          color +
          "  Tamanio:" +
          tamanio +
          "  Ancho:" +
          datosCasilla.ancho;
      }

      return datosCasilla;
    },

    async procesarHorariosDoctorClinica(response) {
      //---Inicio, se genera la lista de especialidades a partir del horario doctor
      //---Se genera el arreglo inicial de horarios de doctor por dia
      const listaEspTemp = Array();

      const fechaInicioBusq = this.$moment(this.datosBusqueda.fechaInicio);
      fechaInicioBusq.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

      const fechaFinBusq = this.$moment(this.datosBusqueda.fechaFin);
      fechaFinBusq.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

      const horaInicioActividades = 700;
      const horaFinActividades = 2359;

      if (
        response.data.data.horariosDoctor !== undefined &&
        response.data.data.horariosDoctor !== null
      ) {
        response.data.data.horariosDoctor.forEach((hd) => {
          hd.horaInicio = hd.horaInicio.toString();
          if (hd.horaInicio.length < 4) {
            hd.horaInicio = "0" + hd.horaInicio;
          }

          hd.horaFin = hd.horaFin.toString();
          if (hd.horaFin.length < 4) {
            hd.horaFin = "0" + hd.horaFin;
          }

          if (hd.horaInicio.toString().length === 4) {
            hd.horaInicioCasilla =
              hd.horaInicio.substr(0, 2) + ":" + hd.horaInicio.substr(2, 3);
          }
          if (hd.horaFin.toString().length === 4) {
            hd.horaFinCasilla =
              hd.horaFin.substr(0, 2) + ":" + hd.horaFin.substr(2, 3);
          }

          const fechaInicioEvento = this.$moment(new Date(hd.fechaInicio));
          fechaInicioEvento.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          const fechaFinEvento = this.$moment(new Date(hd.fechaFin));
          fechaFinEvento.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

          const pos =
            fechaInicioEvento.format("YYYY/MM/DD") +
            "-" +
            hd.horaInicio +
            "-" +
            hd.sillon;
          const obj = {
            idAgendaEmpleado: hd.idAgendaEmpleado,
            sillon: hd.sillon,
            idEmpleado: hd.idEmpleado,
            colorEspecialidad: hd.colorEspecialidad + "4D",
            idEspecialidad: hd.idEspecialidad,
            nombreEspecialidad: hd.nombreEspecialidad,
            periodicidad: hd.periodicidad,
            fechaInicio: fechaInicioEvento,
            fechaFin: fechaFinEvento,
            horaInicio: hd.horaInicio,
            horaFin: hd.horaFin,
            horaInicioCasilla: hd.horaInicioCasilla,
            horaFinCasilla: hd.horaFinCasilla,
            idBloque: hd.idBloque
          };

          if (
            fechaInicioEvento >= fechaInicioBusq &&
            fechaInicioEvento <= fechaFinBusq &&
            Number(obj.horaInicio) >= horaInicioActividades &&
            Number(obj.horaInicio) <= horaFinActividades
          ) {
            listaEspTemp[hd.idEspecialidad] = {
              id: hd.idEspecialidad,
              nombre: hd.nombreEspecialidad,
              color: hd.colorEspecialidad,
            };
          }

          this.horariosDoctor[pos] = obj;

          const horaInicioOriginal = this.$moment(
            "01/01/2020 " + obj.horaInicioCasilla
          );
          const horaFinOriginal = this.$moment(
            "01/01/2020 " + obj.horaFinCasilla
          );

          let nuevaHora = horaInicioOriginal.clone();
          while (nuevaHora < horaFinOriginal) {
            const posOrg =
              fechaInicioEvento.format("YYYY/MM/DD") +
              "-" +
              nuevaHora.format("HHmm") +
              "-" +
              hd.sillon;

            const nuevoHorario = JSON.parse(JSON.stringify(obj));
            nuevoHorario.horaInicio = nuevaHora.clone().format("HHmm");

            if (
              nuevoHorario.periodicidad !== undefined &&
              nuevoHorario.periodicidad === 5
            ) {
              this.horariosDoctor[posOrg] = nuevoHorario;
            } else {
              this.horariosDoctor[posOrg] = nuevoHorario;
            }

            nuevaHora = nuevaHora.add(15, "minutes");
          }
        });

        const horariosDoctorTemp = [];

        for (const hdOrigen in this.horariosDoctor) {
          const hd = this.horariosDoctor[hdOrigen];

          if (hd.horaInicio !== undefined) {
            const fechaInicioOriginal = this.$moment(hd.fechaInicio);
            const fechaFinOriginal = this.$moment(hd.fechaFin);

            let nuevaFecha = fechaInicioOriginal;
            while (nuevaFecha < fechaFinOriginal) {
              if (hd.periodicidad === 5) {
                //periodicidad unica
                break;
              }

              if (hd.periodicidad === 1) {
                nuevaFecha = nuevaFecha.add(1, "weeks");
              } else if (hd.periodicidad === 2) {
                nuevaFecha = nuevaFecha.add(2, "weeks");
              } else if (hd.periodicidad === 3) {
                nuevaFecha = nuevaFecha.add(1, "months");
              } else {
                nuevaFecha = nuevaFecha.add(1, "days");
              }

              const posOrg =
                nuevaFecha.format("YYYY/MM/DD") +
                "-" +
                hd.horaInicio +
                "-" +
                hd.sillon;
              hd.fechaInicio = nuevaFecha.clone();

              if (
                nuevaFecha >= fechaInicioBusq &&
                nuevaFecha <= fechaFinBusq &&
                Number(hd.horaInicio) >= horaInicioActividades &&
                Number(hd.horaInicio) <= horaFinActividades
              ) {
                horariosDoctorTemp[posOrg] = hd;
                listaEspTemp[hd.idEspecialidad] = {
                  id: hd.idEspecialidad,
                  nombre: hd.nombreEspecialidad,
                  color: hd.colorEspecialidad,
                };
              }
            }
          }
        }

        for (const hdTempin in horariosDoctorTemp) {
          const hdTemp = horariosDoctorTemp[hdTempin];

          if (hdTemp.horaInicio !== undefined) {
            this.horariosDoctor[hdTempin] = hdTemp;
          }
        }

        listaEspTemp.forEach((l) => {
          this.listaEspecialidades.push(l);
        });
      }
      return true;
    },
    async procesarHorariosBloqueados(response) {
      if (
        response.data.data.horariosBloqueados !== undefined &&
        response.data.data.horariosBloqueados !== null
      ) {
        response.data.data.horariosBloqueados.forEach((hb) => {
          hb.horaInicio = hb.horaInicio.toString();
          if (hb.horaInicio.length < 4) {
            hb.horaInicio = "0" + hb.horaInicio;
          }

          hb.horaFin = hb.horaFin.toString();
          if (hb.horaFin.length < 4) {
            hb.horaFin = "0" + hb.horaFin;
          }

          if (hb.horaInicio.toString().length === 4) {
            hb.horaInicioCasilla =
              hb.horaInicio.substr(0, 2) + ":" + hb.horaInicio.substr(2, 3);
          }
          if (hb.horaFin.toString().length === 4) {
            hb.horaFinCasilla =
              hb.horaFin.substr(0, 2) + ":" + hb.horaFin.substr(2, 3);
          }

          let fechaInicioHBEvento = this.$moment(new Date(hb.fechaInicio));
          fechaInicioHBEvento.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          const fechaFinHBEvento = this.$moment(new Date(hb.fechaFin));
          fechaFinHBEvento.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          while (fechaInicioHBEvento <= fechaFinHBEvento) {
            const horaInicioOriginal = this.$moment(
              "01/01/2020 " + hb.horaInicioCasilla
            );
            const horaFinOriginal = this.$moment(
              "01/01/2020 " + hb.horaFinCasilla
            );

            let nuevaHora = horaInicioOriginal.clone();
            while (nuevaHora < horaFinOriginal) {
              const posOrg =
                fechaInicioHBEvento.format("YYYY/MM/DD") +
                "-" +
                nuevaHora.format("HHmm") +
                "-" +
                hb.sillon;
              delete this.horariosDoctor[posOrg];
              nuevaHora = nuevaHora.add(15, "minutes");
            }

            fechaInicioHBEvento.add(1, "days");
          }
        });
      }
      return true;
    },

    buscarHorariosClinica() {
      const idClinica = this.datosBusqueda.clinica.clinicaID;
      if (
        idClinica === undefined ||
        idClinica === null ||
        idClinica === 0 ||
        this.datosFormulario === undefined ||
        this.datosFormulario.fechaCita === undefined
      ) {
        return;
      }

      this.loadingHorariosClinica = true;

      const clinicaID = this.datosBusqueda.clinica.clinicaID;

      let fechaInicio = null;
      try {
        fechaInicio = this.$moment(this.datosFormulario.fechaCita)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      } catch (e) {
        fechaInicio = this.datosFormulario.fechaCita
            .utc()
            .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      }

      const parametros = {
        idClinica: clinicaID,
        fechaInicio: fechaInicio
      }
      this.$http
        .post(
          this.$api +
            "agenda/obtenerHorariosClinicaParaAgenda", parametros
        )
        .then((response) => {
          if (response.status === 200 && response.data.data !== undefined) {
            this.procesarHorariosClinica(response)
              .then(() => {
                if (this.$refs.calDentalia !== undefined) {
                  this.$refs.calDentalia.calcularSemana(
                    this.datosBusqueda.fechaInicio,
                    this.eventos,
                    this.horariosDoctor,
                    this.getNumeroSillonesClinica
                  );
                  this.obtenerSemana();
                }
                this.loadingHorariosClinica = false;
              })
              .catch((e) => {
                this.loadingHorariosClinica = false;
                console.error(e);
              });
          }
        })
        .catch((error) => {
          console.error("No hay datos" + error);
          this.loadingHorariosClinica = false;
        });
    },
    async procesarHorariosClinica(response) {
      this.horariosClinica = [];
      if (response.data.data !== undefined && response.data.data !== null) {
        response.data.data.forEach((v) => {
          v.horaInicio = v.horaInicio.toString();

          if (v.horaInicio.length < 4) {
            v.horaInicio = "0" + v.horaInicio;
          }

          v.horaFin = v.horaFin.toString();
          if (v.horaFin.length < 4) {
            v.horaFin = "0" + v.horaFin;
          }

          const fechaEvento = this.$moment(v.fecha).utc().format("YYYY/MM/DD");
          const pos = fechaEvento + "-" + v.sillon;

          const horaIn = v.horaInicio.substr(0, 2);
          const horaFn = v.horaFin.substr(0, 2);
          const minIn = v.horaInicio.substr(2, 3);
          const minFn = v.horaFin.substr(2, 3);

          if (this.horariosClinica[pos] === undefined) {
            this.horariosClinica[pos] = {
              original: [],
              horas: [],
              horasMinutosDate: [],
            };
          }

          this.horariosClinica[pos].original.push(
            horaIn + ":" + minIn + " a " + horaFn + ":" + minFn
          );
          this.horariosClinica[pos].horas.push([
            Number(horaIn),
            Number(horaFn),
          ]);
          this.horariosClinica[pos].horasMinutosDate.push({
            horaInicio: this.$moment(
              fechaEvento + " " + horaIn + ":" + minIn + ":00"
            ),
            horaFin: this.$moment(
              fechaEvento + " " + horaFn + ":" + minFn + ":00"
            ),
          });
        });
      }
      return true;
    },

    actualizarNombreClinica(inicializar) {
      const clinicaSelec = this.listaClinicas.find(
        (it) => it.id === this.datosBusqueda.clinica.clinicaID
      );
      if (clinicaSelec == null) {
        this.$swal.fire({
          icon: "error",
          title: "La clínica acaba de ser desactivada, recargando...",
          timer: 10000,
        });
        setTimeout(() => location.reload(), 3000);
      }
      if (clinicaSelec !== undefined && clinicaSelec !== null) {
        this.datosBusqueda.clinica.nombre = clinicaSelec.nombre;

        if (inicializar) {
          const fechaActual = new Date();
          this.seleccionarFecha(fechaActual);
        } else {
          this.buscarAgenda();
        }

        this.llenarPacientesClinica();
      }
    },
    seleccionarFechaCalendario() {
      this.seleccionarFecha(new Date(this.datosBusqueda.fechaActual));
    },
    seleccionarFechaPorDiaSemana(date) {
      this.datosBusqueda.fechaInicio = date;

      this.datosBusqueda.fechaFin = new Date(this.datosBusqueda.fechaInicio);
      this.datosBusqueda.fechaFin.setDate(
        this.datosBusqueda.fechaFin.getDate() + 7
      );


      this.buscarAgenda();
    },
    seleccionarFecha(date) {
      const fecha = new Date(date.toISOString());
      fecha.setHours(0);
      fecha.setMinutes(0);
      fecha.setMilliseconds(0);

      this.datosBusqueda.fechaInicio = new Date(fecha.toISOString());
      this.datosBusqueda.fechaFin = new Date(fecha.toISOString());

      if (fecha.getDay() === 6) {
        //si es domingo
        this.datosBusqueda.fechaInicio.setDate(fecha.getDate() + 1);
        this.datosBusqueda.fechaFin.setDate(fecha.getDate() + 7);
      } else {
        this.datosBusqueda.fechaInicio.setDate(
          fecha.getDate() - fecha.getDay()
        );
        this.datosBusqueda.fechaFin.setDate(
          fecha.getDate() + (7 - date.getDay())
        );
      }

      this.buscarAgenda();
    },

    buscarCitas(citas){
      const parametros = {citas: citas}
      this.$http
          .post(this.$api + "agenda/obtenerCitasAgendadas", parametros)
          .then((response) => {
            if (response.status === 200) {
             this.citasAgendadas = response.data.data;
             this.modalAvisoOverbooking = true;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },

    saveEvent() {
      if (!this.rangoHoraFormEsValido && !this.citaIsOverbooking) {
        this.$swal.fire({
          icon: "error",
          title: "Selecciona un horario válido para poder continuar",
        });
        return;
      }

      if (
        this.datosFormulario.idPaciente === undefined ||
        this.datosFormulario.idPaciente == null ||
        this.datosFormulario.idPaciente === 0
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Debes buscar y seleccionar un paciente",
        });
        return;
      }

      this.loading = true;

      const datosGuardar = JSON.parse(JSON.stringify(this.datosFormulario));
      var fechaCita = "";
      if (this.citaIsOverbooking) {
        fechaCita = this.$moment(datosGuardar.fechaSinZona).format(
          "YYYY-MM-DD"
        );
      } else {
        fechaCita = this.$moment(datosGuardar.fechaCita).format("YYYY-MM-DD");
      }

      const horaCita = this.$moment(fechaCita);

      datosGuardar.fechaCita = this.$moment(horaCita)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      /*      if (this.citaIsOverbooking) {
        datosGuardar.horaInicio = this.datosFormulario.horaInicio;
        datosGuardar.horaFin = this.datosFormulario.horaFin;
      }else{ */
      datosGuardar.horaInicio =
        datosGuardar.horaInicio.HH + "" + datosGuardar.horaInicio.mm;
      datosGuardar.horaFin =
        datosGuardar.horaFin.HH + "" + datosGuardar.horaFin.mm;
      datosGuardar.idClinica = this.datosBusqueda.clinica.clinicaID;
      datosGuardar.citaAdministrativa = this.citaAdministrativa;
      /* } */

      if (
        datosGuardar.sillon === undefined ||
        datosGuardar.sillon === null ||
        datosGuardar.sillon <= 0
      ) {
        datosGuardar.sillon = 1;
      }

      if (this.secondReagendar) {
        this.submitReagendarCita(datosGuardar);
      } else {
        this.$http
          .post(this.$api + "agenda/registrarCita", datosGuardar)
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                icon: "success",
                title: "La cita se registró con éxito",
              });
              this.second = false;
              this.busquedaOverbooking = false;
              this.citaIsOverbooking = false;
              this.modSobreAsignarDoctor = false;
              this.citaAdministrativa = false;
              this.menuDerecha = true;
              this.seleccionarFecha(new Date(fechaCita));
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response) {
              let mensaje = error.response.data.message;
              console.error(mensaje);
              try {
                if (error.response.data.data !== undefined) {
                  mensaje +=
                    " (Fecha bloqueo del " +
                    this.$formatoFecha(
                      error.response.data.data.fechaInicioBloqueo
                    ) +
                    " al " +
                    this.$formatoFecha(
                      error.response.data.data.fechaFinBloqueo
                    ) +
                    " de " +
                    this.$formatoHora(
                      error.response.data.data.horaInicioBloqueo
                    ) +
                    " a " +
                    this.$formatoHora(error.response.data.data.horaFinBloqueo) +
                    ")";
                }
              } catch (e) {
                console.error(e);
              }

              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Horario ocupado",
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente",
              });
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    submitAgregarAgenda() {
      this.$refs.submitAgregarAgenda.click();

    },
    asignarHoraLlegadaPaciente(datosCita) {
      this.loading = true;
      if (
        (datosCita.pacienteEsNinoNino || datosCita.pacienteEsMixto) &&
        datosCita.idPacientePadre === null
      ) {
        this.loading = false;
        this.$swal
          .fire({
            icon: "info",
            title: "Aviso",
            text: "El paciente es menor de edad, es necesario agregar un tutor",
            confirmButtonColor: "#0e6ba9",
            cancelButtonColor: "#8e8e8e",
            confirmButtonText: "OK",
            cancelButtonText: "CANCELAR",
            showCancelButton: true,
          })
          .then((aceptar) => {
            if (aceptar.value) {
              this.$router.push({
                name: "HistoriaNinoLink",
                params: {
                  idPaciente: this.$global.encriptar(datosCita.idPaciente),
                  idClinica: this.$global.encriptar(datosCita.idClinica),
                },
              });
            }
          });
        return false;
      }
      this.idCita = datosCita.idCita;
      const params = {
        idCita: datosCita.idCita
      }
      this.$http
        .put(
          this.$api +
            "cita/registrar/horadellegadapaciente", params )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.aplicaHojaBienvenida == true) {
              this.$swal({
                icon: "success",
                text:
                  response.data.data.mensaje +
                  " ¿Deseas continuar con la impresion de la hoja de bienvenida?",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCancelButton: true,
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then((aceptar) => {
                if (aceptar.value) {
                  this.verHojaBienvenida();
                }
              });
            } else {
              this.$swal.fire({
                icon: "success",
                title: "Aviso",
                text: response.data.data.mensaje,
              });
            }
            this.fechaLlegada = true;
            this.buscarAgenda();
          }
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Ocurrio un error al realizar el registro de la hora de llegada del paciente",
          });
        })
        .finally(() => (this.loading = false));
    },
    verHojaBienvenida() {
      this.loading = true;

      this.$http
        .get(
          this.$api + "cita/obtener/datoshojabienvenida?idCita=" + this.idCita
        )
        .then((response) => {
          let datos = response.data.data;

          this.nombrePaciente = datos.nombrePaciente;
          this.nombreTagMotivoCita = datos.tagMotivoCita;
          this.idTipoDenticion = datos.idTipoDenticion;
          this.nombreTutor = datos.nombreTutor;
          this.idCita = this.idCita;

          this.$bvModal.show("modal-hoja-bienvenida");
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    iniciarSesion(cita) {
      this.loadingCal = true;
      this.listaPlanesPaciente = Array();
      this.citaSeleccionada = cita;

      this.listaOGCabecera = [];

      this.cargandoKitsCita = true;

      this.datosIniciarSesion = {
        herramientas: true,
        idPlan: undefined,
        idMotivoHerramienta: undefined,
        idKit: undefined,
      };

      this.validarTomaHerramientas();

      const param = {idPaciente: this.citaSeleccionada.idPaciente}
      this.$http
        .post(
          this.$api +
            "paciente/perfiles/obtenerPlanesPaciente/convalidaciondevigencia", param
        )
        .then((response) => {
          if (response.status === 200) {
            this.listaPlanesPaciente = response.data.data
              .filter((item) => item.aplicarDescuento == true)
              .map((it) => {
                return { id: it.id, nombre: it.nombre };
              });
          }
                const parametros = {
                    idClinica: this.citaSeleccionada.idClinica,
                    especialidad: this.citaSeleccionada.idEspecialidadDoctor
                }
                this.$http
                  .post(
                    this.$api +
                      "diagnostico/hoja/obtenerListaDoctoresOGCabeceraClinica", parametros
                  )
                  .then((response) => {
                    this.listaOGCabecera = response.data.data.map((it) => {
                      const especialidades = it.especialidades
                        .map((esp) => esp.nombreEspecialidad)
                        .join(", ");
                      return {
                        id: it.idEmpleado,
                        nombre:
                          it.numeroEmpleado +
                          " " +
                          it.nombreEmpleado +
                          " (" +
                          especialidades +
                          ")",
                      };
                    });
                  })
                  .catch((error) => {
                    console.error(error);
                  });

              this.showDialogIniciarSession = true;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingCal = false;
          this.loading = false;
        });

        const parametros = {idCita: this.citaSeleccionada.idCita}
      this.$http
        .post(
          this.$api +
            "agenda/obtenerKitsTratamientosCita", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.listaKitsCita = response.data.data.map((it) => {
              return {
                id: it.idTratamiento,
                nombre: it.nombre,
              };
            });
            this.listaKitsCitaFiltro = this.listaKitsCita;
          }
          this.cargandoKitsCita = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.cargandoKitsCita = false;
        });
    },

    validarTomaHerramientas() {
      this.loadingExistePTI = true;
      this.noExistePTIVigente = true;
      const parametros = {idPaciente: this.citaSeleccionada.idPaciente}
      this.$http
        .post(
          this.$api +
            "pti/existePtiMayor6Meses", parametros
        )
        .then((response) => {
          this.noExistePTIVigente = response.data.data;
          this.datosIniciarSesion.herramientas = this.noExistePTIVigente;
        })
        .catch((error) => {
          console.error(
            "Error al obtener la validacion de existencia de un pti del  del paciente: " +
              error
          );
        })
        .finally(() => {
          this.loadingExistePTI = false;
          if (this.citaSeleccionada.especialistaNino) {
            this.datosIniciarSesion.herramientas = false;
          }
        });
    },
    iniciarSesion2() {
      const datosIniciarSesion = this.datosIniciarSesion;

      //para validar que no tenga mas de una cita hoy
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      this.loading = true;
      const data = {
        idCita: datosIniciarSesion.citaSeleccionada.idCita,
        idCompania: 1, //dentalia
        idClinica: this.datosBusqueda.clinica.clinicaID,
        idPaciente: datosIniciarSesion.citaSeleccionada.idPaciente,
        idEmpleado: datosIniciarSesion.citaSeleccionada.idDoctor,
        tomaHerramienta: datosIniciarSesion.herramientas,
        idMotivoHerramienta: datosIniciarSesion.idMotivoHerramienta,
        idPlan: datosIniciarSesion.idPlan,
        horaInicio: inicio,
        horaFin: fin,
        idKitDiagnostico: datosIniciarSesion.idKitDiagnostico,
        idOgCabecera: datosIniciarSesion.idOgCabecera,
      };
      this.$http
        .post(this.$api + "agenda/iniciarSesion", data)
        .then((response) => {
          if (response.status === 200) {
            if (!response.data.data) {
              this.$router.push("/dashboard");
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "El paciente ya cuenta con una sesión activa, no se puede crear otra nueva",
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Ocurrio un error al realizar el registro del inicio de sesión, contacte al administrador e intente nuevamente",
          });
        })
        .finally(() => (this.loading = false));
    },
    consultarDetalle(cita) {
      this.datosDetalleOriginal = cita;
      this.datosDetalle = cita[0];
      this.datosDetalle.comentarioNuevo = "";
      this.showDetail = true;
      this.selectPaciente = this.datosDetalle((cita) => {
        return {
          idCita: cita.idCita,
          nombrePaciente: cita.nombrePaciente,
        };
      });
    },

    citasAgenda() {},

    consultarDetallePorPaciente() {
      this.datosDetalle = this.datosDetalleOriginal.find(
        (element) => element.idCita == this.pacienteSeleccionado.idCita
      );
    },
    initDatosCitaNueva() {
      this.datosFormulario = {
        nombrePacienteBusqueda: null,
        idPaciente: null,
        idDoctor: null,
        idConfianza: null,
        sillon: 1,
        fechaCita: new Date(),
        horaInicio: {
          HH: "08",
          mm: "00",
        },
        horaFin: {
          HH: "08",
          mm: "00",
        },
        comentario: null,
        idCompania: 1,
        idClinica: null,
        idCanalOrigen: 1,
        idEspecialidad: null,
        idTratamiento: null,
        idTagMotivoCita: null,
      };
      this.tagMotivoCita();
    },
    crearCitaDesdeCalendario(datosAgregar) {
      this.initDatosCitaNueva();

      if (datosAgregar.sillon >= 100) {
        if (!this.$localStorageService.can("CA_06_crear_cita_embajador")) {
          return;
        }

        this.datosFormulario.citaEmbajador = true;
      }

      if (datosAgregar.sillon !== undefined && datosAgregar.sillon !== null) {
        this.datosFormulario.sillon = datosAgregar.sillon;
      }

      if (
        datosAgregar.idEspecialidad !== undefined &&
        datosAgregar.idEspecialidad !== null
      ) {
        this.datosFormulario.idEspecialidad = datosAgregar.idEspecialidad;
      }

      if (
        datosAgregar.idEmpleado !== undefined &&
        datosAgregar.idEmpleado !== null
      ) {
        this.datosFormulario.idDoctor = datosAgregar.idEmpleado;
      }

      if (
        datosAgregar.fechaCita !== undefined &&
        datosAgregar.fechaCita !== null
      ) {
        this.datosFormulario.fechaCita = datosAgregar.fechaCita;
      }

      if (datosAgregar.hora !== undefined && datosAgregar.hora !== null) {
        this.datosFormulario.horaInicio = {
          HH: datosAgregar.hora,
          mm: datosAgregar.minuto,
        };
        this.datosFormulario.horaFin = {
          HH: datosAgregar.hora,
          mm: "59",
        };
      }

      this.listaPacientes = Array();
      this.secondCitaDesdeCalendario = true;
      this.secondReagendar = false;
      this.second = true;

      this.buscarHorariosClinica();
      this.llenarEspecialidadesDoctor(false);
      this.llenarDoctoresClinica(this.datosBusqueda.clinica.clinicaID);
    },

    mostrarModalCrearCita(citaEmbajador) {
      if (
        this.datosBusqueda.idEspecialidad !== undefined &&
        this.datosBusqueda.idEspecialidad !== null
      ) {
        this.datosFormulario.idEspecialidad = this.datosBusqueda.idEspecialidad;
      }

      if (
        this.datosBusqueda.empleadoId !== undefined &&
        this.datosBusqueda.empleadoId !== null
      ) {
        this.datosFormulario.idDoctor = this.datosBusqueda.clinica.empleadoId;
      }

      this.secondCitaDesdeCalendario = false;
      this.secondReagendar = false;
      this.modalsActivos = true;
      if (citaEmbajador) {
        this.second = true;
      }
      this.initDatosCitaNueva();

      this.llenarEspecialidadesDoctor(false);

      this.listaPacientes = Array();

      this.datosFormulario.citaEmbajador = citaEmbajador;
      this.datosFormulario.sillon = !citaEmbajador ? 1 : 100;
      
      const idClinica = this.datosBusqueda.clinica.clinicaID;

      this.buscarHorariosClinica();
      this.menuDerecha = false;
      if (citaEmbajador) {
        this.llenarDoctoresEmbajadorClinica(idClinica);
      } else {
        this.llenarDoctoresClinica(idClinica);
      }
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    setearPaciente(item) {
      this.datosFormulario.idPaciente = item.id;
      this.datosFormulario.nombrePaciente = item.name;
      this.datosFormulario.esPacienteNuevo = item.esPacienteNuevo;
      this.datosFormulario.indicadorProbabilidad = item.indicadorProbabilidad;
      this.datosFormulario.telefono = item.telefono;
      this.datosFormulario.correo = item.correo;

      this.idTagMotivoCita = undefined;
      this.datosFormulario.idTratamiento = undefined;
      this.datosFormulario.nombreTratamiento =
        "--Primero selecciona un motivo--";

      window.scrollTo(0, 0);
      this.tagMotivoCita();
    },
    setearMotivoTag(item) {
      if (this.datosFormulario.esPacienteNuevo) {
        const datos = JSON.parse(JSON.stringify(this.tagmotivocitaDatosArray));
        const tratamientos = datos.filter((it) => it.idTagMotivoCita === item);
        if (tratamientos !== undefined && tratamientos[0] !== undefined) {
          this.datosFormulario.idTratamiento = tratamientos[0].idTratamiento;
          this.datosFormulario.nombreTratamiento =
            tratamientos[0].nombreTratamiento.toUpperCase();
        }
      }
    },

    submitConfirmarCita() {
      const idCita = this.pacienteSeleccionado.idCita;
      this.loading = true;
      var params = {};
      if (this.listaConfirmarCita != null) {
        params = {
        idCita: idCita,
        idMotivoEspera: this.listaConfirmarCita.idMotivoEspera,
        comentario: this.listaConfirmarCita.comentario,
        usuarioModificacion: this.$localStorageService.getIdUsuario(),
      };
      }else{
        params = {
        idCita: idCita,
        idMotivoEspera: null,
        comentario: "",
        usuarioModificacion: this.$localStorageService.getIdUsuario(),
      };
      }
     
      this.loading = true;
      this.$http
        .put(this.$api + "cita/confirmar", params)
        .then((response) => {
          if (response.status === 200) {
            this.isCitaConfirmada = true;
            this.$swal.fire({
              icon: "success",
              title: "La cita se confirmo con éxito",
            });
            this.$bvModal.hide("modConfirmarCita");
            this.buscarAgenda();
            this.showDetail = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.response.data.message,
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error al realizar la confirmación, contacte al administrador e intente nuevamente",
            });
          }

          this.loading = false;
        });
    },

    reagendarCita(datosAgregar) {
      this.initDatosCitaNueva();

      this.datosFormulario = JSON.parse(JSON.stringify(datosAgregar));


      this.datosFormulario.idEspecialidad =
        datosAgregar.tratamientos[0].idEspecialidad;
      this.datosFormulario.idTratamiento =
        datosAgregar.tratamientos[0].idTratamiento;

      const horaInicio = datosAgregar.horaInicioCasilla;
      const horaFin = datosAgregar.horaFinCasilla;
      this.datosFormulario.horaInicio = {
        HH: horaInicio.substring(0, 2),
        mm: horaInicio.substring(3, 5),
      };
      this.datosFormulario.horaFin = {
        HH: horaFin.substring(0, 2),
        mm: horaFin.substring(3, 5),
      };

      const fechaActual = new Date();
      fechaActual.setMinutes(0, 0, 0);
      if (new Date(this.datosFormulario.fechaCita) < fechaActual) {
        this.datosFormulario.fechaCita = new Date();
      }

      this.listaPacientes = Array();

      this.secondCitaDesdeCalendario = false;
      this.secondReagendar = true;
      this.second = true;

      this.listaDoctores = [];

      if (this.datosFormulario.citaSobreAsignada) {
        this.llenarDoctoresEspecialistasClinica(
          this.datosBusqueda.clinica.clinicaID
        );
      } else if (this.datosFormulario.citaEmbajador) {
        this.llenarDoctoresEmbajadorClinica(
          this.datosBusqueda.clinica.clinicaID
        );
      } else {
        this.llenarDoctoresClinica(this.datosBusqueda.clinica.clinicaID);
      }

      this.llenarEspecialidadesDoctor(false);

      this.buscarHorariosClinica();
    },
    submitReagendarCita(datosCita) {
      this.loading = true;
      datosCita.tratamientos = undefined;
      this.$http
        .post(this.$api + "agenda/reagendarCita", datosCita)
        .then((response) => {
          if (response.status === 200) {
            this.$swal.fire({
              icon: "success",
              title: "La cita se reagendo con éxito",
            });
            this.$bvModal.hide("modConfirmarCita");
            this.second = false;
            this.citaAdministrativa = false;
            this.showDetail = false;
            this.buscarAgenda();
          }
          this.modSobreAsignarDoctor = false;
        })
        .catch((error) => {
          if (error.response) {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.response.data.message,
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error al realizar la reagenda de la cita, contacte al administrador e intente nuevamente",
            });
          }

          this.loading = false;
        });
    },

    cancelarCita(cita) {
      this.showDialogCancelarCita = true;
      this.datosCita = JSON.parse(JSON.stringify(cita));
      this.datosCancelarCita = {
        idCita: this.datosCita.idCita,
        idUsuario: this.$localStorageService.getIdUsuario(),
        motivoCancelacion: undefined,
        descripcionCancelacion: undefined,
      };
    },

    submitCancelarCita() {
      this.$refs.submitCancelarCita.click();
    },

    cancelarCitaServ() {
      const datosCancelarCita = this.datosCancelarCita;
      this.$http
        .put(
          this.$api +
            "cita/cancelar/id?" +
            "idCita=" +
            datosCancelarCita.idCita +
            "&idUsuario=" +
            datosCancelarCita.idUsuario +
            "&motivoCancelacion=" +
            datosCancelarCita.motivoCancelacion +
            "&descripcionCancelacion=" +
            datosCancelarCita.descripcionCancelacion
        )
        .then((response) => {
          if (response.status === 200) {
            this.$swal.fire({
              icon: "success",
              title: "La cita se canceló con éxito",
            });

            this.$bvModal.hide("modCancelarCita");
            this.buscarAgenda();
            this.showDetail = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.response.data.message,
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error al realizar la cancelación, contacte al administrador e intente nuevamente",
            });
          }

          this.loading = false;
        });
    },

    submitReasignarDoctor() {
      this.$refs.submitReasignarDoctor.click();
    },
    reasignarDoctor(cita) {
      this.datosFormularioReasignar = JSON.parse(JSON.stringify(cita));
      this.datosFormulario = JSON.parse(JSON.stringify(cita));

      this.listaDoctores = [];

      if (this.datosFormularioReasignar.citaSobreAsignada) {
        this.llenarDoctoresEspecialistasClinica(
          this.datosBusqueda.clinica.clinicaID
        ).then(() => (this.modalReasignarDoctor = true));
      } else if (this.datosFormularioReasignar.citaEmbajador) {
        this.llenarDoctoresEmbajadorClinica(
          this.datosBusqueda.clinica.clinicaID
        ).then(() => (this.modalReasignarDoctor = true));
      } else {
        this.llenarDoctoresClinica(this.datosBusqueda.clinica.clinicaID).then(
          () => (this.modalReasignarDoctor = true)
        );
      }
    },
    guardarReasignarDoctor() {
      this.loading = true;
      const params = {
        idCita: this.datosFormularioReasignar.idCita,
        idDoctor: this.datosFormularioReasignar.idDoctor
      }
      this.$http
        .put(
          this.$api +
            "agenda/reasignarCita",
            params
        )
        .then((response) => {
          this.loading = false;

          this.$swal.fire({
            icon: "success",
            title: response.data.message,
          });
          this.showDetail = false;
          this.modalReasignarDoctor = false;
          this.buscarAgenda();
        })
        .catch((error) => {
          if (error.response) {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.response.data.message,
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error al realizar la confirmación, contacte al administrador e intente nuevamente",
            });
          }

          this.loading = false;
        });
    },

    submitAgregarObs() {
      this.$refs.submitAgregarObs.click();
    },
    agregarObservacion() {
      this.guardando = true;
      this.$swal({
        icon: "warning",
        text: "Estás por agregar nuevas observaciones a la cita, ¿deseas continuar?",
        title: "Observaciones",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http
            .post(this.$api + "agenda/agregarObservacionCita", {
              idCita: this.datosDetalle.idCita,
              observaciones:
                this.datosDetalle.comentarioNuevo,
            })
            .then(() => {
              this.$swal.fire({
                icon: "success",
                title: "Aviso",
                text: "Se agregó la observación a la cita de manera éxitosa",
              });
              this.showDetail = false;
              this.buscarAgenda();
            })
            .catch((error) => {
              console.error("Error", error);
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al agregar la observación a la cita",
              });
            })
            .finally(() => {
              this.guardando = false;
            });
        } else {
          this.guardando = false;
        }
      });
    },

    obtenerEspecialidadesDoctor(doctor) {
      if (
        doctor.especialidades != undefined &&
        doctor.especialidades !== null
      ) {
        return doctor.especialidades
          .map((esp) => esp.nombreEspecialidad)
          .join(", ");
      } else {
        return "-";
      }
    },
    tagMotivoCita() {
      this.tagmotivocitaDatosArray = [];

      if (
        this.datosFormulario !== undefined &&
        this.datosFormulario !== null &&
        this.datosFormulario.idPaciente !== undefined &&
        this.datosFormulario.idPaciente !== null
      ) {
        this.$http
          .get(
            this.$api +
              "tagmotivocita/tagmotivocita/paciente?idPaciente=" +
              this.datosFormulario.idPaciente
          )
          .then((response) => {
            this.tagmotivocitaDatosArray = response.data.data;
            this.tagmotivocitaDatosArrayFiltro = this.tagmotivocitaDatosArray;
            this.listaDoctores = [];
            if (this.datosFormulario.citaEmbajador) {
              this.llenarDoctoresEmbajadorClinica(
                this.datosBusqueda.clinica.clinicaID
              );
            } else {
              this.llenarDoctoresEspecialistasClinica(
                this.datosBusqueda.clinica.clinicaID
              );
            }
          });
      }
    },
    mostrarDetalle(cita) {
      this.showDetail = true;
      this.menuDerecha = false;
      this.datosDetalleOriginal = cita.citas.sort(function (a, b) {
        return (
          new Date(b.fechaCreacion).getTime() -
          new Date(a.fechaCreacion).getTime()
        );
      });
      this.posicionPacienteOriginal = this.datosDetalleOriginal.length - 1;
      this.pacienteSeleccionado =
        this.datosDetalleOriginal[this.posicionPacienteOriginal];
      this.fechaLlegada = this.pacienteSeleccionado.fechaLlegada;

      this.datosDetalleOriginal.forEach((element) => {
        element.isCitaConfirmada =
          element.estatusCita == "CONFIRMADA" ? true : false;
        let color = element.color.replace(/background: rgb/g, "");
        let colorSombrero =  element.colorEstatusSDI;
        let sinComa = color.replace(/;/g, "");
        element.colorCitaOverbooking =
          "border-color: " +
          " rgb" +
          sinComa +
          " rgb" +
          sinComa +
          " rgb" +
          sinComa +
          colorSombrero +
          ";border-width:3px 3px 3px 17px;width: 70%; height: 20%; margin:2%;box-shadow: 0px 4px 26px -11px rgba(0,0,0,0.59);border-radius: 10px;border-style: solid;";
      });
    },
  },
};
</script>

<style scoped>

.animacionBoton:hover {background-color: #ededed}

.fade-in-bck {
  -webkit-animation: fade-in-bck 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-bck 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-bck {
  0% {
    -webkit-transform: translateZ(80px);
    transform: translateZ(80px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes fade-in-bck {
  0% {
    -webkit-transform: translateZ(80px);
    transform: translateZ(80px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
}

.selectWeek {
  color: #1b81af;
  font-weight: 600;
  font-size: 25px;
}

.fade-out-right {
  -webkit-animation: fade-out-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: fade-out-right 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes fade-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
}
@keyframes fade-out-right {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
}

.fade-in-right {
  -webkit-animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-left {
  -webkit-animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.sticky-container {
  position: fixed;
  right: 0px;
  top: 50px;

  z-index: 1100;
}

.sticky li {
  border-radius: 20px 0px 0px 20px;
  box-shadow: -10px 11px 17px -6px rgba(0, 0, 0, 0.12);

  list-style-type: none;
  background-color: #fff;
  color: #efefef;
  height: 650px;
  padding: 10px;
  margin: 0px 0px 1px 0px;
}

.sticky li p {
  padding-top: 5px;
  margin: 0px;
  line-height: 16px;
  font-size: 11px;
}
.sticky li p a {
  text-decoration: none;
  color: #2c3539;
}
.sticky li p a:hover {
  text-decoration: underline;
}
.bCardAgenda {
  margin: 0.5%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.color {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 16px;
  border: 1px solid #ddd !important;
}

.centrar {
  display: flex;
  justify-content: center;
}

.dropbtn {
  background-color: #3498db;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropup {
  position: relative;
  display: inline-block;
}

.dropup-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  bottom: 50px;
  z-index: 1;
}

.dropup-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropup-content a:hover {
  background-color: #ccc;
}

.dropup:hover .dropup-content {
  display: block;
}

.dropup:hover .dropbtn {
  background-color: #2980b9;
}
</style>
